/* eslint-disable prettier/prettier */
/* eslint-disable react/prop-types */

import TextField from "@mui/material/TextField";
import Alert from "@mui/material/Alert";
import Autocomplete from "@mui/material/Autocomplete";
import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { map, filter } from "lodash";
import { useSelector } from "react-redux";
import { useState, state, forwardRef, useImperativeHandle } from "react";
import toast from "react-hot-toast";
import validator from "validator";
import Divider from "@mui/material/Divider";
import Button from "@mui/material/Button";

const AntecedentesPerinatales = forwardRef(
  ({ Back, Next, props, vista = "registrar", desactivar }, ref) => {
    const [TuvoMeningitis, setTuvoMeningitis] = useState(props?.tuvoMeningitis ?? null);
    const [isvalid_TuvoMeningitis, isvalid_setTuvoMeningitis] = useState(false);

    const [VentilacionMecanica, setVentilacionMecanica] = useState(
      props?.ventilacionMecanica ?? null
    );
    const [isvalid_VentilacionMecanica, isvalid_setVentilacionMecanica] = useState(false);

    const [Malformacion, setMalformacion] = useState(props?.malformacion ?? null);
    const [isvalid_Malformacion, isvalid_setMalformacion] = useState(false);

    const [CualMalformacion, setCualMalformacion] = useState(
      props?.cualMalformacion ? props.cualMalformacion : ""
    );
    const [isvalid_CualMalformacion, isvalid_setCualMalformacion] = useState(false);

    const [CrisisConvulsivas, setCrisisConvulsivas] = useState(props?.crisisConvulsivas ?? null);
    const [isvalid_CrisisConvulsivas, isvalid_setCrisisConvulsivas] = useState(false);

    const [TomadoMedicamentos, setTomadoMedicamentos] = useState(props?.tomadoMedicamentos ?? null);
    const [isvalid_TomadoMedicamentos, isvalid_setTomadoMedicamentos] = useState(false);

    const [CualesMedicamentos, setCualesMedicamentos] = useState(
      props?.cualesMedicamentos ? props.cualesMedicamentos : ""
    );
    const [isvalid_CualesMedicamentos, isvalid_setCualesMedicamentos] = useState(false);

    const [GolpesCabeza, setGolpesCabeza] = useState(props?.golpesCabeza ?? null);
    const [isvalid_GolpesCabeza, isvalid_setGolpesCabeza] = useState(false);

    const [EspecifiqueGolpes, setEspecifiqueGolpes] = useState(
      props?.especifiqueGolpes ? props.especifiqueGolpes : ""
    );
    const [isvalid_EspecifiqueGolpes, isvalid_setEspecifiqueGolpes] = useState(false);

    const [TamizNeoMetabolico, setTamizNeoMetabolico] = useState(props?.tamizNeoMetabolico ?? null);
    const [isvalid_TamizNeoMetabolico, isvalid_setTamizNeoMetabolico] = useState(false);

    const [ResTamizNeoMetabolico, setResTamizNeoMetabolico] = useState(
      props?.resTamizNeoMetabolico ? props.resTamizNeoMetabolico : ""
    );
    const [isvalid_ResTamizNeoMetabolico, isvalid_setResTamizNeoMetabolico] = useState(false);

    const [TamizNeoAuditivo, setTamizNeoAuditivo] = useState(props?.tamizNeoAuditivo ?? null);
    const [isvalid_TamizNeoAuditivo, isvalid_setTamizNeoAuditivo] = useState(false);

    const [ResTamizNeoAuditivo, setResTamizNeoAuditivo] = useState(
      props?.resTamizNeoAuditivo ? props.resTamizNeoAuditivo : ""
    );
    const [isvalid_ResTamizNeoAuditivo, isvalid_setResTamizNeoAuditivo] = useState(false);

    const [TamizNeoVisual, setTamizNeoVisual] = useState(props?.tamizNeoVisual ?? null);
    const [isvalid_TamizNeoVisual, isvalid_setTamizNeoVisual] = useState(false);

    const [ResTamizNeoVisual, setResTamizNeoVisual] = useState(
      props?.resTamizNeoVisual ? props.resTamizNeoVisual : ""
    );
    const [isvalid_ResTamizNeoVisual, isvalid_setResTamizNeoVisual] = useState(false);

    const [TamizNeoCardiaco, setTamizNeoCardiaco] = useState(props?.tamizNeoCardiaco ?? null);
    const [isvalid_TamizNeoCardiaco, isvalid_setTamizNeoCardiaco] = useState(false);

    const [ResTamizNeoCardiaco, setResTamizNeoCardiaco] = useState(
      props?.resTamizNeoCardiaco ? props.resTamizNeoCardiaco : ""
    );
    const [isvalid_ResTamizNeoCardiaco, isvalid_setResTamizNeoCardiaco] = useState(false);

    const [MedicamentosActuales, setMedicamentosActuales] = useState(
      props?.medicamentosActuales ? props.medicamentosActuales : ""
    );
    const [isvalid_MedicamentosActuales, isvalid_setMedicamentosActuales] = useState(false);

    const [InfeccionesOido, setInfeccionesOido] = useState(props?.infeccionesOido ?? null);
    const [isvalid_InfeccionesOido, isvalid_setInfeccionesOido] = useState(false);

    const [EspecifiqueInfeccionesOido, setEspecifiqueInfeccionesOido] = useState(
      props?.especifiqueInfeccionesOido ? props.especifiqueInfeccionesOido : ""
    );
    const [isvalid_EspecifiqueInfeccionesOido, isvalid_setEspecifiqueInfeccionesOido] =
      useState(false);

    const [InfeccionesGarganta, setInfeccionesGarganta] = useState(
      props?.infeccionesGarganta ?? null
    );
    const [isvalid_InfeccionesGarganta, isvalid_setInfeccionesGarganta] = useState(false);

    const [Ronca, setRonca] = useState(props?.ronca ?? null);
    const [isvalid_Ronca, isvalid_setRonca] = useState(false);

    const [TieneCirugias, setTieneCirugias] = useState(props?.tieneCirugias ?? null);
    const [isvalid_TieneCirugias, isvalid_setTieneCirugias] = useState(false);

    const [EspecifiqueCirugias, setEspecifiqueCirugias] = useState(
      props?.especifiqueCirugias ? props.especifiqueCirugias : ""
    );
    const [isvalid_EspecifiqueCirugias, isvalid_setEspecifiqueCirugias] = useState(false);

    const [ProblemaAlimentacion, setProblemaAlimentacion] = useState(
      props?.problemaAlimentacion ?? null
    );
    const [isvalid_ProblemaAlimentacion, isvalid_setProblemaAlimentacion] = useState(false);

    const [EspecifiqueProbAlimenta, setEspecifiqueProbAlimenta] = useState(
      props?.especifiqueProbAlimenta ? props.especifiqueProbAlimenta : ""
    );
    const [isvalid_EspecifiqueProbAlimenta, isvalid_setEspecifiqueProbAlimenta] = useState(false);

    const [Hospitalizado, setHospitalizado] = useState(props?.hospitalizado ?? null);
    const [isvalid_Hospitalizado, isvalid_setHospitalizado] = useState(false);

    const [IdInfeccionCMV, setIdInfeccionCMV] = useState(props?.infeccionCMV ?? null);
    const [isvalid_IdInfeccionCMV, isvalid_setIdInfeccionCMV] = useState(false);

    const [EspecifiqueInfeccionCMV, setEspecifiqueInfeccionCMV] = useState(
      props?.especifiqueInfeccionCMV ? props.especifiqueInfeccionCMV : ""
    );

    const [isvalid_EspecifiqueInfeccionCMV, isvalid_setEspecifiqueInfeccionCMV] = useState(false);

    const ValidaForm = () => {
      if (TuvoMeningitis === null || TuvoMeningitis === undefined) {
        toast.error("Campo obligatorio *");
        isvalid_setTuvoMeningitis(true);
        return null;
      }

      if (VentilacionMecanica === null || VentilacionMecanica === undefined) {
        toast.error("Campo obligatorio *");
        isvalid_setVentilacionMecanica(true);
        return null;
      }

      if (Malformacion === null || Malformacion === undefined) {
        toast.error("Campo obligatorio *");
        isvalid_setMalformacion(true);
        return null;
      }

      if (!CualMalformacion && Malformacion == "1") {
        toast.error("Campo obligatorio *");
        isvalid_setCualMalformacion(true);
        return null;
      }

      if (CrisisConvulsivas === null || CrisisConvulsivas === undefined) {
        toast.error("Campo obligatorio *");
        isvalid_setCrisisConvulsivas(true);
        return null;
      }

      if (TomadoMedicamentos === null || TomadoMedicamentos === undefined) {
        toast.error("Campo obligatorio *");
        isvalid_setTomadoMedicamentos(true);
        return null;
      }

      if (!CualesMedicamentos && TomadoMedicamentos == "1") {
        toast.error("Campo obligatorio *");
        isvalid_setCualesMedicamentos(true);
        return null;
      }

      if (GolpesCabeza === null || GolpesCabeza === undefined) {
        toast.error("Campo obligatorio *");
        isvalid_setGolpesCabeza(true);
        return null;
      }

      if (!EspecifiqueGolpes && GolpesCabeza == "1") {
        toast.error("Campo obligatorio *");
        isvalid_setEspecifiqueGolpes(true);
        return null;
      }

      if (TamizNeoMetabolico === null || TamizNeoMetabolico === undefined) {
        toast.error("Campo obligatorio *");
        isvalid_setTamizNeoMetabolico(true);
        return null;
      }

      if (!ResTamizNeoMetabolico && TamizNeoMetabolico == "1") {
        toast.error("Campo obligatorio *");
        isvalid_setResTamizNeoMetabolico(true);
        return null;
      }

      if (TamizNeoAuditivo === null || TamizNeoAuditivo === undefined) {
        toast.error("Campo obligatorio *");
        isvalid_setTamizNeoAuditivo(true);
        return null;
      }

      if (!ResTamizNeoAuditivo && TamizNeoAuditivo == "1") {
        toast.error("Campo obligatorio *");
        isvalid_setResTamizNeoAuditivo(true);
        return null;
      }

      if (TamizNeoVisual === null || TamizNeoVisual === undefined) {
        toast.error("Campo obligatorio *");
        isvalid_setTamizNeoVisual(true);
        return null;
      }

      if (!ResTamizNeoVisual && TamizNeoVisual == "1") {
        toast.error("Campo obligatorio *");
        isvalid_setResTamizNeoVisual(true);
        return null;
      }

      if (TamizNeoCardiaco === null || TamizNeoCardiaco === undefined) {
        toast.error("Campo obligatorio *");
        isvalid_setTamizNeoCardiaco(true);
        return null;
      }

      if (!ResTamizNeoCardiaco && TamizNeoCardiaco == "1") {
        toast.error("Campo obligatorio *");
        isvalid_setResTamizNeoCardiaco(true);
        return null;
      }

      /*  if (!MedicamentosActuales) {
            toast.error("Campo obligatorio *");
            isvalid_setMedicamentosActuales(true);
            return null;
            }*/

      if (InfeccionesOido === null || InfeccionesOido === undefined) {
        toast.error("Campo obligatorio *");
        isvalid_setInfeccionesOido(true);
        return null;
      }

      if (!EspecifiqueInfeccionesOido && InfeccionesOido == "1") {
        toast.error("Campo obligatorio *");
        isvalid_setEspecifiqueInfeccionesOido(true);
        return null;
      }

      if (InfeccionesGarganta === null || InfeccionesGarganta === undefined) {
        toast.error("Campo obligatorio *");
        isvalid_setInfeccionesGarganta(true);
        return null;
      }

      if (Ronca === null || Ronca === undefined) {
        toast.error("Campo obligatorio *");
        isvalid_setRonca(true);
        return null;
      }

      if (TieneCirugias === null || TieneCirugias === undefined) {
        toast.error("Campo obligatorio *");
        isvalid_setTieneCirugias(true);
        return null;
      }

      if (!EspecifiqueCirugias && TieneCirugias == "1") {
        toast.error("Campo obligatorio *");
        isvalid_setEspecifiqueCirugias(true);
        return null;
      }

      if (ProblemaAlimentacion === null || ProblemaAlimentacion === undefined) {
        toast.error("Campo obligatorio *");
        isvalid_setProblemaAlimentacion(true);
        return null;
      }

      if (!EspecifiqueProbAlimenta && ProblemaAlimentacion == "1") {
        toast.error("Campo obligatorio *");
        isvalid_setEspecifiqueProbAlimenta(true);
        return null;
      }

      if (Hospitalizado === null || Hospitalizado === undefined) {
        toast.error("Campo obligatorio *");
        isvalid_setHospitalizado(true);
        return null;
      }

      if (IdInfeccionCMV === null || IdInfeccionCMV === undefined) {
        toast.error("Campo obligatorio *");
        isvalid_setIdInfeccionCMV(true);
        return null;
      }

      if (!EspecifiqueInfeccionCMV && IdInfeccionCMV == "1") {
        toast.error("Campo obligatorio *");
        isvalid_setEspecifiqueInfeccionCMV(true);
        return null;
      }

      const datosFormulario = {
        tuvoMeningitis: TuvoMeningitis,
        ventilacionMecanica: VentilacionMecanica,
        malformacion: Malformacion,
        cualMalformacion: CualMalformacion,
        crisisConvulsivas: CrisisConvulsivas,
        tomadoMedicamentos: TomadoMedicamentos,
        cualesMedicamentos: CualesMedicamentos,
        golpesCabeza: GolpesCabeza,
        especifiqueGolpes: EspecifiqueGolpes,
        tamizNeoMetabolico: TamizNeoMetabolico,
        resTamizNeoMetabolico: ResTamizNeoMetabolico,
        tamizNeoAuditivo: TamizNeoAuditivo,
        resTamizNeoAuditivo: ResTamizNeoAuditivo,
        tamizNeoVisual: TamizNeoVisual,
        resTamizNeoVisual: ResTamizNeoVisual,
        tamizNeoCardiaco: TamizNeoCardiaco,
        resTamizNeoCardiaco: ResTamizNeoCardiaco,
        medicamentosActuales: MedicamentosActuales,
        infeccionesOido: InfeccionesOido,
        especifiqueInfeccionesOido: EspecifiqueInfeccionesOido,
        infeccionesGarganta: InfeccionesGarganta,
        ronca: Ronca,
        tieneCirugias: TieneCirugias,
        especifiqueCirugias: EspecifiqueCirugias,
        problemaAlimentacion: ProblemaAlimentacion,
        especifiqueProbAlimenta: EspecifiqueProbAlimenta,
        hospitalizado: Hospitalizado,
        infeccionCMV: IdInfeccionCMV,
        especifiqueInfeccionCMV: EspecifiqueInfeccionCMV,
      };

      Next(datosFormulario);
      return datosFormulario;
    };

    //Métodos para guardar los datos editados:
    useImperativeHandle(ref, () => ({
      ejecutarNext: () => {
        return ValidaForm();
      },
    }));

    const handleBack = () => {
      const data = {
        tuvoMeningitis: TuvoMeningitis,
        ventilacionMecanica: VentilacionMecanica,
        malformacion: Malformacion,
        cualMalformacion: CualMalformacion,
        crisisConvulsivas: CrisisConvulsivas,
        tomadoMedicamentos: TomadoMedicamentos,
        cualesMedicamentos: CualesMedicamentos,
        golpesCabeza: GolpesCabeza,
        especifiqueGolpes: EspecifiqueGolpes,
        tamizNeoMetabolico: TamizNeoMetabolico,
        resTamizNeoMetabolico: ResTamizNeoMetabolico,
        tamizNeoAuditivo: TamizNeoAuditivo,
        resTamizNeoAuditivo: ResTamizNeoAuditivo,
        tamizNeoVisual: TamizNeoVisual,
        resTamizNeoVisual: ResTamizNeoVisual,
        tamizNeoCardiaco: TamizNeoCardiaco,
        resTamizNeoCardiaco: ResTamizNeoCardiaco,
        medicamentosActuales: MedicamentosActuales,
        infeccionesOido: InfeccionesOido,
        especifiqueInfeccionesOido: EspecifiqueInfeccionesOido,
        infeccionesGarganta: InfeccionesGarganta,
        ronca: Ronca,
        tieneCirugias: TieneCirugias,
        especifiqueCirugias: EspecifiqueCirugias,
        problemaAlimentacion: ProblemaAlimentacion,
        especifiqueProbAlimenta: EspecifiqueProbAlimenta,
        hospitalizado: Hospitalizado,
        infeccionCMV: IdInfeccionCMV,
        especifiqueInfeccionCMV: EspecifiqueInfeccionCMV,
      };

      Back(data);
    };

    return (
      <>
        <Grid container spacing={2}>
          <Grid item xs={12} md={3} lg={3}>
            <MDBox textAlign="right">
              <MDTypography variant="h6" color="white" style={{ opacity: 0.7, fontSize: "0.9rem" }}>
                ¿Ha tenido meningitis?
              </MDTypography>
            </MDBox>
          </Grid>
          <Grid item xs={12} md={9} lg={9}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={4} lg={4}>
                <Autocomplete
                  options={[
                    { label: "Sí", value: "1" },
                    { label: "No", value: "0" },
                  ]}
                  getOptionLabel={(option) => option.label}
                  disabled={desactivar}
                  id="TuvoMeningitis"
                  value={
                    [
                      { label: "Sí", value: "1" },
                      { label: "No", value: "0" },
                    ].find((opt) => opt.value == TuvoMeningitis) || null
                  }
                  onChange={(event, newValue) =>
                    setTuvoMeningitis(newValue ? newValue.value : null)
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Seleccione"
                      variant="outlined"
                      autoComplete="new-password"
                      error={isvalid_TuvoMeningitis}
                      helperText={isvalid_TuvoMeningitis ? "Campo obligatorio *" : ""}
                      onFocus={() => {
                        isvalid_setTuvoMeningitis(false);
                      }}
                      onBlur={() => {
                        if (TuvoMeningitis == null) isvalid_setTuvoMeningitis(true);
                      }}
                    />
                  )}
                  style={{ width: "100%", marginBottom: "1rem" }}
                  size="small"
                />
              </Grid>
              <Grid item xs={12} md={4} lg={4}>
                <MDBox textAlign="right">
                  <MDTypography
                    variant="h6"
                    color="white"
                    style={{ opacity: 0.7, fontSize: "0.9rem" }}
                  >
                    ¿Requirió ventilación mecánica?
                  </MDTypography>
                </MDBox>
              </Grid>
              <Grid item xs={12} md={4} lg={4}>
                <Autocomplete
                  options={[
                    { label: "Sí", value: "1" },
                    { label: "No", value: "0" },
                  ]}
                  getOptionLabel={(option) => option.label}
                  disabled={desactivar}
                  id="VentilacionMecanica"
                  value={
                    [
                      { label: "Sí", value: "1" },
                      { label: "No", value: "0" },
                    ].find((opt) => opt.value == VentilacionMecanica) || null
                  }
                  onChange={(event, newValue) =>
                    setVentilacionMecanica(newValue ? newValue.value : null)
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Seleccione"
                      variant="outlined"
                      autoComplete="new-password"
                      error={isvalid_VentilacionMecanica}
                      helperText={isvalid_VentilacionMecanica ? "Campo obligatorio *" : ""}
                      onFocus={() => {
                        isvalid_setVentilacionMecanica(false);
                        if (TuvoMeningitis == null) {
                          isvalid_setTuvoMeningitis(true);
                        }
                      }}
                      onBlur={() => {
                        if (VentilacionMecanica == null) isvalid_setVentilacionMecanica(true);
                      }}
                    />
                  )}
                  style={{ width: "100%", marginBottom: "1rem" }}
                  size="small"
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid container spacing={2}>
          <Grid item xs={12} md={3} lg={3}>
            <MDBox textAlign="right">
              <MDTypography variant="h6" color="white" style={{ opacity: 0.7, fontSize: "0.9rem" }}>
                ¿Tiene alguna malformación?
              </MDTypography>
            </MDBox>
          </Grid>
          <Grid item xs={12} md={9} lg={9}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={4} lg={4}>
                <Autocomplete
                  options={[
                    { label: "Sí", value: "1" },
                    { label: "No", value: "0" },
                  ]}
                  getOptionLabel={(option) => option.label}
                  disabled={desactivar}
                  id="Malformacion"
                  value={
                    [
                      { label: "Sí", value: "1" },
                      { label: "No", value: "0" },
                    ].find((opt) => opt.value == Malformacion) || null
                  }
                  onChange={(event, newValue) => {
                    setMalformacion(newValue ? newValue.value : null);
                    if (newValue != null && newValue.value == "1") {
                      isvalid_setCualMalformacion(true);
                    } else {
                      isvalid_setCualMalformacion(false);
                      setCualMalformacion("");
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      autoComplete="new-password"
                      label="Seleccione"
                      variant="outlined"
                      error={isvalid_Malformacion}
                      helperText={isvalid_Malformacion ? "Campo obligatorio *" : ""}
                      onFocus={() => {
                        isvalid_setMalformacion(false);
                        if (TuvoMeningitis == null) {
                          isvalid_setTuvoMeningitis(true);
                        }
                        if (VentilacionMecanica === null) {
                          isvalid_setVentilacionMecanica(true);
                        }
                      }}
                      onBlur={() => {
                        if (Malformacion == null) isvalid_setMalformacion(true);
                      }}
                    />
                  )}
                  style={{ width: "100%", marginBottom: "1rem" }}
                  size="small"
                />
              </Grid>
              <Grid item xs={12} md={2} lg={2}>
                <MDBox textAlign="right">
                  <MDTypography
                    variant="h6"
                    color="white"
                    style={{ opacity: 0.7, fontSize: "0.9rem" }}
                  >
                    ¿Cuál?
                  </MDTypography>
                </MDBox>
              </Grid>
              <Grid item xs={12} md={6} lg={6}>
                <TextField
                  autoComplete="off"
                  fullWidth
                  variant="outlined"
                  label="Especifique"
                  disabled={desactivar}
                  error={isvalid_CualMalformacion}
                  helperText={isvalid_CualMalformacion ? "Campo obligatorio *" : ""}
                  value={CualMalformacion}
                  onChange={(e) => {
                    if (Malformacion != null && Malformacion == "1") {
                      setCualMalformacion(e.target.value);
                    }
                  }}
                  onFocus={() => {
                    isvalid_setCualMalformacion(false);
                    if (TuvoMeningitis == null) {
                      isvalid_setTuvoMeningitis(true);
                    }
                    if (VentilacionMecanica === null) {
                      isvalid_setVentilacionMecanica(true);
                    }
                    if (Malformacion == null) {
                      isvalid_setMalformacion(true);
                    }
                  }}
                  onBlur={() => {
                    if (!CualMalformacion && Malformacion != null && Malformacion == "1") {
                      isvalid_setCualMalformacion(true);
                    }
                  }}
                  size="small"
                  style={{ marginBottom: "1rem" }}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid container spacing={2}>
          <Grid item xs={12} md={3} lg={3}>
            <MDBox textAlign="right">
              <MDTypography variant="h6" color="white" style={{ opacity: 0.7, fontSize: "0.9rem" }}>
                ¿Ha tenido crisis convulsivas?
              </MDTypography>
            </MDBox>
          </Grid>
          <Grid item xs={12} md={9} lg={9}>
            <Autocomplete
              options={[
                { label: "Sí", value: "1" },
                { label: "No", value: "0" },
              ]}
              getOptionLabel={(option) => option.label}
              disabled={desactivar}
              id="CrisisConvulsivas"
              value={
                [
                  { label: "Sí", value: "1" },
                  { label: "No", value: "0" },
                ].find((opt) => opt.value == CrisisConvulsivas) || null
              }
              onChange={(event, newValue) => setCrisisConvulsivas(newValue ? newValue.value : null)}
              renderInput={(params) => (
                <TextField
                  {...params}
                  autoComplete="new-password"
                  label="Seleccione"
                  variant="outlined"
                  error={isvalid_CrisisConvulsivas}
                  helperText={isvalid_CrisisConvulsivas ? "Campo obligatorio *" : ""}
                  onFocus={() => {
                    isvalid_setCrisisConvulsivas(false);
                    if (TuvoMeningitis == null) {
                      isvalid_setTuvoMeningitis(true);
                    }
                    if (VentilacionMecanica === null) {
                      isvalid_setVentilacionMecanica(true);
                    }
                    if (Malformacion == null) {
                      isvalid_setMalformacion(true);
                    }
                    if (!CualMalformacion && Malformacion == 1) {
                      isvalid_setCualMalformacion(true);
                    }
                  }}
                  onBlur={() => {
                    if (CrisisConvulsivas == null) isvalid_setCrisisConvulsivas(true);
                  }}
                />
              )}
              style={{ width: "100%", marginBottom: "1rem" }}
              size="small"
            />
          </Grid>
        </Grid>

        <Grid container spacing={2}>
          <Grid item xs={12} md={3} lg={3}>
            <MDBox textAlign="right">
              <MDTypography variant="h6" color="white" style={{ opacity: 0.7, fontSize: "0.9rem" }}>
                ¿Ha tomado algún medicamento?
              </MDTypography>
            </MDBox>
          </Grid>
          <Grid item xs={12} md={9} lg={9}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={4} lg={4}>
                <Autocomplete
                  options={[
                    { label: "Sí", value: "1" },
                    { label: "No", value: "0" },
                  ]}
                  getOptionLabel={(option) => option.label}
                  disabled={desactivar}
                  id="TomadoMedicamentos"
                  value={
                    [
                      { label: "Sí", value: "1" },
                      { label: "No", value: "0" },
                    ].find((opt) => opt.value == TomadoMedicamentos) || null
                  }
                  onChange={(event, newValue) => {
                    setTomadoMedicamentos(newValue ? newValue.value : null);
                    if (newValue != null && newValue.value == "1") {
                      isvalid_setCualesMedicamentos(true);
                    } else {
                      isvalid_setCualesMedicamentos(false);
                      setCualesMedicamentos("");
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      autoComplete="new-password"
                      label="Seleccione"
                      variant="outlined"
                      error={isvalid_TomadoMedicamentos}
                      helperText={isvalid_TomadoMedicamentos ? "Campo obligatorio *" : ""}
                      onFocus={() => {
                        isvalid_setTomadoMedicamentos(false);
                        if (TuvoMeningitis == null) {
                          isvalid_setTuvoMeningitis(true);
                        }
                        if (VentilacionMecanica === null) {
                          isvalid_setVentilacionMecanica(true);
                        }
                        if (Malformacion == null) {
                          isvalid_setMalformacion(true);
                        }
                        if (!CualMalformacion && Malformacion == 1) {
                          isvalid_setCualMalformacion(true);
                        }
                        if (CrisisConvulsivas == null) {
                          isvalid_setCrisisConvulsivas(true);
                        }
                      }}
                      onBlur={() => {
                        if (TomadoMedicamentos == null) isvalid_setTomadoMedicamentos(true);
                      }}
                    />
                  )}
                  style={{ width: "100%", marginBottom: "1rem" }}
                  size="small"
                />
              </Grid>
              <Grid item xs={12} md={2} lg={2}>
                <MDBox textAlign="right">
                  <MDTypography
                    variant="h6"
                    color="white"
                    style={{ opacity: 0.7, fontSize: "0.9rem" }}
                  >
                    ¿Cuáles?
                  </MDTypography>
                </MDBox>
              </Grid>
              <Grid item xs={12} md={6} lg={6}>
                <TextField
                  fullWidth
                  variant="outlined"
                  label="Especifique"
                  disabled={desactivar}
                  value={CualesMedicamentos}
                  error={isvalid_CualesMedicamentos}
                  helperText={isvalid_CualesMedicamentos ? "Campo obligatorio *" : ""}
                  onFocus={() => {
                    isvalid_setCualesMedicamentos(false);
                    if (TuvoMeningitis == null) {
                      isvalid_setTuvoMeningitis(true);
                    }
                    if (VentilacionMecanica === null) {
                      isvalid_setVentilacionMecanica(true);
                    }
                    if (Malformacion == null) {
                      isvalid_setMalformacion(true);
                    }
                    if (!CualMalformacion && Malformacion == 1) {
                      isvalid_setCualMalformacion(true);
                    }
                    if (CrisisConvulsivas == null) {
                      isvalid_setCrisisConvulsivas(true);
                    }
                    if (TomadoMedicamentos == null) {
                      isvalid_setTomadoMedicamentos(true);
                    }
                  }}
                  onChange={(e) => {
                    if (TomadoMedicamentos != null && TomadoMedicamentos == "1") {
                      setCualesMedicamentos(e.target.value);
                    }
                  }}
                  onBlur={() => {
                    if (
                      !CualesMedicamentos &&
                      TomadoMedicamentos != null &&
                      TomadoMedicamentos == "1"
                    ) {
                      isvalid_setCualesMedicamentos(true);
                    }
                  }}
                  size="small"
                  style={{ marginBottom: "1rem" }}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        {/* GolpesCabeza y EspecifiqueGolpes */}
        <Grid container spacing={2}>
          <Grid item xs={12} md={3} lg={3}>
            <MDBox textAlign="right">
              <MDTypography variant="h6" color="white" style={{ opacity: 0.7, fontSize: "0.9rem" }}>
                ¿Ha tenido caídas o golpes en cabeza?
              </MDTypography>
            </MDBox>
          </Grid>
          <Grid item xs={12} md={9} lg={9}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={4} lg={4}>
                <Autocomplete
                  options={[
                    { label: "Sí", value: "1" },
                    { label: "No", value: "0" },
                  ]}
                  getOptionLabel={(option) => option.label}
                  disabled={desactivar}
                  id="GolpesCabeza"
                  value={
                    [
                      { label: "Sí", value: "1" },
                      { label: "No", value: "0" },
                    ].find((opt) => opt.value == GolpesCabeza) || null
                  }
                  onChange={(event, newValue) => {
                    setGolpesCabeza(newValue ? newValue.value : null);
                    if (newValue != null && newValue.value == "1") {
                      isvalid_setEspecifiqueGolpes(true);
                    } else {
                      isvalid_setEspecifiqueGolpes(false);
                      setEspecifiqueGolpes("");
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      autoComplete="new-password"
                      label="Seleccione"
                      variant="outlined"
                      error={isvalid_GolpesCabeza}
                      helperText={isvalid_GolpesCabeza ? "Campo obligatorio *" : ""}
                      onFocus={() => {
                        isvalid_setGolpesCabeza(false);
                        if (TuvoMeningitis == null) {
                          isvalid_setTuvoMeningitis(true);
                        }
                        if (VentilacionMecanica === null) {
                          isvalid_setVentilacionMecanica(true);
                        }
                        if (Malformacion == null) {
                          isvalid_setMalformacion(true);
                        }
                        if (!CualMalformacion && Malformacion == 1) {
                          isvalid_setCualMalformacion(true);
                        }
                        if (CrisisConvulsivas == null) {
                          isvalid_setCrisisConvulsivas(true);
                        }
                        if (TomadoMedicamentos == null) {
                          isvalid_setTomadoMedicamentos(true);
                        }
                        if (!CualesMedicamentos && TomadoMedicamentos == 1) {
                          isvalid_setCualesMedicamentos(true);
                        }
                      }}
                      onBlur={() => {
                        if (GolpesCabeza == null) isvalid_setGolpesCabeza(true);
                      }}
                    />
                  )}
                  style={{ width: "100%", marginBottom: "1rem" }}
                  size="small"
                />
              </Grid>
              <Grid item xs={12} md={2} lg={2}>
                <MDBox textAlign="right">
                  <MDTypography
                    variant="h6"
                    color="white"
                    style={{ opacity: 0.7, fontSize: "0.9rem" }}
                  >
                    Especifique
                  </MDTypography>
                </MDBox>
              </Grid>
              <Grid item xs={12} md={6} lg={6}>
                <TextField
                  fullWidth
                  variant="outlined"
                  label="Especifique"
                  disabled={desactivar}
                  value={EspecifiqueGolpes}
                  error={isvalid_EspecifiqueGolpes}
                  helperText={isvalid_EspecifiqueGolpes ? "Campo obligatorio *" : ""}
                  onFocus={() => {
                    isvalid_setEspecifiqueGolpes(false);
                    if (TuvoMeningitis == null) {
                      isvalid_setTuvoMeningitis(true);
                    }
                    if (VentilacionMecanica === null) {
                      isvalid_setVentilacionMecanica(true);
                    }
                    if (Malformacion == null) {
                      isvalid_setMalformacion(true);
                    }
                    if (!CualMalformacion && Malformacion == 1) {
                      isvalid_setCualMalformacion(true);
                    }
                    if (CrisisConvulsivas == null) {
                      isvalid_setCrisisConvulsivas(true);
                    }
                    if (TomadoMedicamentos == null) {
                      isvalid_setTomadoMedicamentos(true);
                    }
                    if (!CualesMedicamentos && TomadoMedicamentos == 1) {
                      isvalid_setCualesMedicamentos(true);
                    }
                    if (GolpesCabeza == null) {
                      isvalid_setGolpesCabeza(true);
                    }
                  }}
                  onChange={(e) => {
                    if (GolpesCabeza != null && GolpesCabeza == "1") {
                      setEspecifiqueGolpes(e.target.value);
                    }
                  }}
                  onBlur={() => {
                    if (!EspecifiqueGolpes && GolpesCabeza != null && GolpesCabeza == "1") {
                      isvalid_setEspecifiqueGolpes(true);
                    }
                  }}
                  size="small"
                  style={{ marginBottom: "1rem" }}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        {/* Tamiz neonatal metabólico + Resultado */}
        <Grid container spacing={2}>
          <Grid item xs={12} md={3} lg={3}>
            <MDBox textAlign="right">
              <MDTypography variant="h6" color="white" style={{ opacity: 0.7, fontSize: "0.9rem" }}>
                ¿Se le hizo el Tamiz neonatal metabólico?
              </MDTypography>
            </MDBox>
          </Grid>
          <Grid item xs={12} md={9} lg={9}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={4} lg={4}>
                <Autocomplete
                  options={[
                    { label: "Sí", value: "1" },
                    { label: "No", value: "0" },
                  ]}
                  getOptionLabel={(option) => option.label}
                  disabled={desactivar}
                  id="TamizNeoMetabolico"
                  value={
                    [
                      { label: "Sí", value: "1" },
                      { label: "No", value: "0" },
                    ].find((opt) => opt.value == TamizNeoMetabolico) || null
                  }
                  onChange={(event, newValue) => {
                    setTamizNeoMetabolico(newValue ? newValue.value : null);
                    if (newValue != null && newValue.value == "1") {
                      isvalid_setResTamizNeoMetabolico(true);
                    } else {
                      isvalid_setResTamizNeoMetabolico(false);
                      setResTamizNeoMetabolico("");
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      autoComplete="new-password"
                      label="Seleccione"
                      variant="outlined"
                      error={isvalid_TamizNeoMetabolico}
                      helperText={isvalid_TamizNeoMetabolico ? "Campo obligatorio *" : ""}
                      onFocus={() => {
                        isvalid_setTamizNeoMetabolico(false);
                        if (TuvoMeningitis == null) {
                          isvalid_setTuvoMeningitis(true);
                        }
                        if (VentilacionMecanica === null) {
                          isvalid_setVentilacionMecanica(true);
                        }
                        if (Malformacion == null) {
                          isvalid_setMalformacion(true);
                        }
                        if (!CualMalformacion && Malformacion == 1) {
                          isvalid_setCualMalformacion(true);
                        }
                        if (CrisisConvulsivas == null) {
                          isvalid_setCrisisConvulsivas(true);
                        }
                        if (TomadoMedicamentos == null) {
                          isvalid_setTomadoMedicamentos(true);
                        }
                        if (!CualesMedicamentos && TomadoMedicamentos == 1) {
                          isvalid_setCualesMedicamentos(true);
                        }
                        if (GolpesCabeza == null) {
                          isvalid_setGolpesCabeza(true);
                        }
                        if (!EspecifiqueGolpes && GolpesCabeza == 1) {
                          isvalid_setEspecifiqueGolpes(true);
                        }
                      }}
                      onBlur={() => {
                        if (TamizNeoMetabolico == null) isvalid_setTamizNeoMetabolico(true);
                      }}
                    />
                  )}
                  size="small"
                  style={{ width: "100%", marginBottom: "1rem" }}
                />
              </Grid>
              <Grid item xs={12} md={8} lg={8}>
                <TextField
                  fullWidth
                  variant="outlined"
                  label="Resultado"
                  disabled={desactivar}
                  autoComplete="off"
                  value={ResTamizNeoMetabolico}
                  error={isvalid_ResTamizNeoMetabolico}
                  helperText={isvalid_ResTamizNeoMetabolico ? "Campo obligatorio *" : ""}
                  onFocus={() => {
                    isvalid_setResTamizNeoMetabolico(false);
                    if (TuvoMeningitis == null) {
                      isvalid_setTuvoMeningitis(true);
                    }
                    if (VentilacionMecanica === null) {
                      isvalid_setVentilacionMecanica(true);
                    }
                    if (Malformacion == null) {
                      isvalid_setMalformacion(true);
                    }
                    if (!CualMalformacion && Malformacion == 1) {
                      isvalid_setCualMalformacion(true);
                    }
                    if (CrisisConvulsivas == null) {
                      isvalid_setCrisisConvulsivas(true);
                    }
                    if (TomadoMedicamentos == null) {
                      isvalid_setTomadoMedicamentos(true);
                    }
                    if (!CualesMedicamentos && TomadoMedicamentos == 1) {
                      isvalid_setCualesMedicamentos(true);
                    }
                    if (GolpesCabeza == null) {
                      isvalid_setGolpesCabeza(true);
                    }
                    if (!EspecifiqueGolpes && GolpesCabeza == 1) {
                      isvalid_setEspecifiqueGolpes(true);
                    }
                    if (TamizNeoMetabolico == null) {
                      isvalid_setTamizNeoMetabolico(true);
                    }
                  }}
                  onChange={(e) => {
                    if (TamizNeoMetabolico != null && TamizNeoMetabolico == "1") {
                      setResTamizNeoMetabolico(e.target.value);
                    }
                  }}
                  onBlur={() => {
                    if (
                      !ResTamizNeoMetabolico &&
                      TamizNeoMetabolico != null &&
                      TamizNeoMetabolico == "1"
                    ) {
                      isvalid_setResTamizNeoMetabolico(true);
                    }
                  }}
                  size="small"
                  style={{ marginBottom: "1rem" }}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        {/* Tamiz neonatal auditivo + Resultado */}
        <Grid container spacing={2}>
          <Grid item xs={12} md={3} lg={3}>
            <MDBox textAlign="right">
              <MDTypography variant="h6" color="white" style={{ opacity: 0.7, fontSize: "0.9rem" }}>
                ¿Se le hizo el Tamiz neonatal auditivo?
              </MDTypography>
            </MDBox>
          </Grid>
          <Grid item xs={12} md={9} lg={9}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={4} lg={4}>
                <Autocomplete
                  options={[
                    { label: "Sí", value: "1" },
                    { label: "No", value: "0" },
                  ]}
                  getOptionLabel={(option) => option.label}
                  disabled={desactivar}
                  id="TamizNeoAuditivo"
                  value={
                    [
                      { label: "Sí", value: "1" },
                      { label: "No", value: "0" },
                    ].find((opt) => opt.value == TamizNeoAuditivo) || null
                  }
                  onChange={(event, newValue) => {
                    setTamizNeoAuditivo(newValue ? newValue.value : null);
                    if (newValue != null && newValue.value == "1") {
                      isvalid_setResTamizNeoAuditivo(true);
                    } else {
                      isvalid_setResTamizNeoAuditivo(false);
                      setResTamizNeoAuditivo("");
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      autoComplete="new-password"
                      label="Seleccione"
                      variant="outlined"
                      error={isvalid_TamizNeoAuditivo}
                      helperText={isvalid_TamizNeoAuditivo ? "Campo obligatorio *" : ""}
                      onFocus={() => {
                        isvalid_setTamizNeoAuditivo(false);
                        if (TuvoMeningitis == null) {
                          isvalid_setTuvoMeningitis(true);
                        }
                        if (VentilacionMecanica === null) {
                          isvalid_setVentilacionMecanica(true);
                        }
                        if (Malformacion == null) {
                          isvalid_setMalformacion(true);
                        }
                        if (!CualMalformacion && Malformacion == 1) {
                          isvalid_setCualMalformacion(true);
                        }
                        if (CrisisConvulsivas == null) {
                          isvalid_setCrisisConvulsivas(true);
                        }
                        if (TomadoMedicamentos == null) {
                          isvalid_setTomadoMedicamentos(true);
                        }
                        if (!CualesMedicamentos && TomadoMedicamentos == 1) {
                          isvalid_setCualesMedicamentos(true);
                        }
                        if (GolpesCabeza == null) {
                          isvalid_setGolpesCabeza(true);
                        }
                        if (!EspecifiqueGolpes && GolpesCabeza == 1) {
                          isvalid_setEspecifiqueGolpes(true);
                        }
                        if (TamizNeoMetabolico == null) {
                          isvalid_setTamizNeoMetabolico(true);
                        }
                        if (!ResTamizNeoMetabolico && TamizNeoMetabolico == 1) {
                          isvalid_setResTamizNeoMetabolico(true);
                        }
                      }}
                      onBlur={() => {
                        if (TamizNeoAuditivo == null) isvalid_setTamizNeoAuditivo(true);
                      }}
                    />
                  )}
                  size="small"
                  style={{ width: "100%", marginBottom: "1rem" }}
                />
              </Grid>
              <Grid item xs={12} md={8} lg={8}>
                <TextField
                  fullWidth
                  variant="outlined"
                  label="Resultado"
                  disabled={desactivar}
                  autoComplete="off"
                  value={ResTamizNeoAuditivo}
                  error={isvalid_ResTamizNeoAuditivo}
                  helperText={isvalid_ResTamizNeoAuditivo ? "Campo obligatorio *" : ""}
                  onFocus={() => {
                    isvalid_setResTamizNeoAuditivo(false);
                    if (TuvoMeningitis == null) {
                      isvalid_setTuvoMeningitis(true);
                    }
                    if (VentilacionMecanica === null) {
                      isvalid_setVentilacionMecanica(true);
                    }
                    if (Malformacion == null) {
                      isvalid_setMalformacion(true);
                    }
                    if (!CualMalformacion && Malformacion == 1) {
                      isvalid_setCualMalformacion(true);
                    }
                    if (CrisisConvulsivas == null) {
                      isvalid_setCrisisConvulsivas(true);
                    }
                    if (TomadoMedicamentos == null) {
                      isvalid_setTomadoMedicamentos(true);
                    }
                    if (!CualesMedicamentos && TomadoMedicamentos == 1) {
                      isvalid_setCualesMedicamentos(true);
                    }
                    if (GolpesCabeza == null) {
                      isvalid_setGolpesCabeza(true);
                    }
                    if (!EspecifiqueGolpes && GolpesCabeza == 1) {
                      isvalid_setEspecifiqueGolpes(true);
                    }
                    if (TamizNeoMetabolico == null) {
                      isvalid_setTamizNeoMetabolico(true);
                    }
                    if (!ResTamizNeoMetabolico && TamizNeoMetabolico == 1) {
                      isvalid_setResTamizNeoMetabolico(true);
                    }
                    if (TamizNeoAuditivo == null) {
                      isvalid_setTamizNeoAuditivo(true);
                    }
                  }}
                  onChange={(e) => {
                    if (TamizNeoAuditivo != null && TamizNeoAuditivo == "1") {
                      setResTamizNeoAuditivo(e.target.value);
                    }
                  }}
                  onBlur={() => {
                    if (
                      !ResTamizNeoAuditivo &&
                      TamizNeoAuditivo != null &&
                      TamizNeoAuditivo == "1"
                    ) {
                      isvalid_setResTamizNeoAuditivo(true);
                    }
                  }}
                  size="small"
                  style={{ marginBottom: "1rem" }}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        {/* Tamiz neonatal visual + Resultado */}
        <Grid container spacing={2}>
          <Grid item xs={12} md={3} lg={3}>
            <MDBox textAlign="right">
              <MDTypography variant="h6" color="white" style={{ opacity: 0.7, fontSize: "0.9rem" }}>
                ¿Se le hizo el Tamiz neonatal visual?
              </MDTypography>
            </MDBox>
          </Grid>
          <Grid item xs={12} md={9} lg={9}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={4} lg={4}>
                <Autocomplete
                  options={[
                    { label: "Sí", value: "1" },
                    { label: "No", value: "0" },
                  ]}
                  getOptionLabel={(option) => option.label}
                  disabled={desactivar}
                  id="TamizNeoVisual"
                  value={
                    [
                      { label: "Sí", value: "1" },
                      { label: "No", value: "0" },
                    ].find((opt) => opt.value == TamizNeoVisual) || null
                  }
                  onChange={(event, newValue) => {
                    setTamizNeoVisual(newValue ? newValue.value : null);
                    if (newValue != null && newValue.value == "1") {
                      isvalid_setResTamizNeoVisual(true);
                    } else {
                      isvalid_setResTamizNeoVisual(false);
                      setResTamizNeoVisual("");
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      autoComplete="new-password"
                      label="Seleccione"
                      variant="outlined"
                      error={isvalid_TamizNeoVisual}
                      helperText={isvalid_TamizNeoVisual ? "Campo obligatorio *" : ""}
                      onFocus={() => {
                        isvalid_setTamizNeoVisual(false);
                        if (TuvoMeningitis == null) {
                          isvalid_setTuvoMeningitis(true);
                        }
                        if (VentilacionMecanica === null) {
                          isvalid_setVentilacionMecanica(true);
                        }
                        if (Malformacion == null) {
                          isvalid_setMalformacion(true);
                        }
                        if (!CualMalformacion && Malformacion == 1) {
                          isvalid_setCualMalformacion(true);
                        }
                        if (CrisisConvulsivas == null) {
                          isvalid_setCrisisConvulsivas(true);
                        }
                        if (TomadoMedicamentos == null) {
                          isvalid_setTomadoMedicamentos(true);
                        }
                        if (!CualesMedicamentos && TomadoMedicamentos == 1) {
                          isvalid_setCualesMedicamentos(true);
                        }
                        if (GolpesCabeza == null) {
                          isvalid_setGolpesCabeza(true);
                        }
                        if (!EspecifiqueGolpes && GolpesCabeza == 1) {
                          isvalid_setEspecifiqueGolpes(true);
                        }
                        if (TamizNeoMetabolico == null) {
                          isvalid_setTamizNeoMetabolico(true);
                        }
                        if (!ResTamizNeoMetabolico && TamizNeoMetabolico == 1) {
                          isvalid_setResTamizNeoMetabolico(true);
                        }
                        if (TamizNeoAuditivo == null) {
                          isvalid_setTamizNeoAuditivo(true);
                        }
                        if (!ResTamizNeoAuditivo && TamizNeoAuditivo == 1) {
                          isvalid_setResTamizNeoAuditivo(true);
                        }
                      }}
                      onBlur={() => {
                        if (TamizNeoVisual == null) isvalid_setTamizNeoVisual(true);
                      }}
                    />
                  )}
                  size="small"
                  style={{ width: "100%", marginBottom: "1rem" }}
                />
              </Grid>
              <Grid item xs={12} md={8} lg={8}>
                <TextField
                  fullWidth
                  variant="outlined"
                  label="Resultado"
                  disabled={desactivar}
                  autoComplete="off"
                  value={ResTamizNeoVisual}
                  error={isvalid_ResTamizNeoVisual}
                  helperText={isvalid_ResTamizNeoVisual ? "Campo obligatorio *" : ""}
                  onFocus={() => {
                    isvalid_setResTamizNeoVisual(false);
                    isvalid_setTamizNeoVisual(false);
                    if (TuvoMeningitis == null) {
                      isvalid_setTuvoMeningitis(true);
                    }
                    if (VentilacionMecanica === null) {
                      isvalid_setVentilacionMecanica(true);
                    }
                    if (Malformacion == null) {
                      isvalid_setMalformacion(true);
                    }
                    if (!CualMalformacion && Malformacion == 1) {
                      isvalid_setCualMalformacion(true);
                    }
                    if (CrisisConvulsivas == null) {
                      isvalid_setCrisisConvulsivas(true);
                    }
                    if (TomadoMedicamentos == null) {
                      isvalid_setTomadoMedicamentos(true);
                    }
                    if (!CualesMedicamentos && TomadoMedicamentos == 1) {
                      isvalid_setCualesMedicamentos(true);
                    }
                    if (GolpesCabeza == null) {
                      isvalid_setGolpesCabeza(true);
                    }
                    if (!EspecifiqueGolpes && GolpesCabeza == 1) {
                      isvalid_setEspecifiqueGolpes(true);
                    }
                    if (TamizNeoMetabolico == null) {
                      isvalid_setTamizNeoMetabolico(true);
                    }
                    if (!ResTamizNeoMetabolico && TamizNeoMetabolico == 1) {
                      isvalid_setResTamizNeoMetabolico(true);
                    }
                    if (TamizNeoAuditivo == null) {
                      isvalid_setTamizNeoAuditivo(true);
                    }
                    if (!ResTamizNeoAuditivo && TamizNeoAuditivo == 1) {
                      isvalid_setResTamizNeoAuditivo(true);
                    }
                    if (TamizNeoVisual == null) {
                      isvalid_setTamizNeoVisual(true);
                    }
                  }}
                  onChange={(e) => {
                    if (TamizNeoVisual != null && TamizNeoVisual == "1") {
                      setResTamizNeoVisual(e.target.value);
                    }
                  }}
                  onBlur={() => {
                    if (!ResTamizNeoVisual && TamizNeoVisual != null && TamizNeoVisual == "1") {
                      isvalid_setResTamizNeoVisual(true);
                    }
                  }}
                  size="small"
                  style={{ marginBottom: "1rem" }}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        {/* Tamiz neonatal cardiaco + Resultado */}
        <Grid container spacing={2}>
          <Grid item xs={12} md={3} lg={3}>
            <MDBox textAlign="right">
              <MDTypography variant="h6" color="white" style={{ opacity: 0.7, fontSize: "0.9rem" }}>
                ¿Se le hizo el Tamiz neonatal cardiaco?
              </MDTypography>
            </MDBox>
          </Grid>
          <Grid item xs={12} md={9} lg={9}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={4} lg={4}>
                <Autocomplete
                  options={[
                    { label: "Sí", value: "1" },
                    { label: "No", value: "0" },
                  ]}
                  getOptionLabel={(option) => option.label}
                  disabled={desactivar}
                  id="TamizNeoCardiaco"
                  value={
                    [
                      { label: "Sí", value: "1" },
                      { label: "No", value: "0" },
                    ].find((opt) => opt.value == TamizNeoCardiaco) || null
                  }
                  onChange={(event, newValue) => {
                    setTamizNeoCardiaco(newValue ? newValue.value : null);
                    if (newValue != null && newValue.value == "1") {
                      isvalid_setResTamizNeoCardiaco(true);
                    } else {
                      isvalid_setResTamizNeoCardiaco(false);
                      setResTamizNeoCardiaco("");
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      autoComplete="new-password"
                      label="Seleccione"
                      variant="outlined"
                      error={isvalid_TamizNeoCardiaco}
                      helperText={isvalid_TamizNeoCardiaco ? "Campo obligatorio *" : ""}
                      onFocus={() => {
                        isvalid_setTamizNeoCardiaco(false);
                        if (TuvoMeningitis == null) {
                          isvalid_setTuvoMeningitis(true);
                        }
                        if (VentilacionMecanica === null) {
                          isvalid_setVentilacionMecanica(true);
                        }
                        if (Malformacion == null) {
                          isvalid_setMalformacion(true);
                        }
                        if (!CualMalformacion && Malformacion == 1) {
                          isvalid_setCualMalformacion(true);
                        }
                        if (CrisisConvulsivas == null) {
                          isvalid_setCrisisConvulsivas(true);
                        }
                        if (TomadoMedicamentos == null) {
                          isvalid_setTomadoMedicamentos(true);
                        }
                        if (!CualesMedicamentos && TomadoMedicamentos == 1) {
                          isvalid_setCualesMedicamentos(true);
                        }
                        if (GolpesCabeza == null) {
                          isvalid_setGolpesCabeza(true);
                        }
                        if (!EspecifiqueGolpes && GolpesCabeza == 1) {
                          isvalid_setEspecifiqueGolpes(true);
                        }
                        if (TamizNeoMetabolico == null) {
                          isvalid_setTamizNeoMetabolico(true);
                        }
                        if (!ResTamizNeoMetabolico && TamizNeoMetabolico == 1) {
                          isvalid_setResTamizNeoMetabolico(true);
                        }
                        if (TamizNeoAuditivo == null) {
                          isvalid_setTamizNeoAuditivo(true);
                        }
                        if (!ResTamizNeoAuditivo && TamizNeoAuditivo == 1) {
                          isvalid_setResTamizNeoAuditivo(true);
                        }
                        if (TamizNeoVisual == null) {
                          isvalid_setTamizNeoVisual(true);
                        }
                        if (!ResTamizNeoVisual && TamizNeoVisual == 1) {
                          isvalid_setResTamizNeoVisual(true);
                        }
                      }}
                      onBlur={() => {
                        if (TamizNeoCardiaco == null) isvalid_setTamizNeoCardiaco(true);
                      }}
                    />
                  )}
                  size="small"
                  style={{ width: "100%", marginBottom: "1rem" }}
                />
              </Grid>
              <Grid item xs={12} md={8} lg={8}>
                <TextField
                  fullWidth
                  variant="outlined"
                  label="Resultado"
                  disabled={desactivar}
                  autoComplete="off"
                  value={ResTamizNeoCardiaco}
                  error={isvalid_ResTamizNeoCardiaco}
                  helperText={isvalid_ResTamizNeoCardiaco ? "Campo obligatorio *" : ""}
                  onFocus={() => {
                    isvalid_setResTamizNeoCardiaco(false);
                    if (TuvoMeningitis == null) {
                      isvalid_setTuvoMeningitis(true);
                    }
                    if (VentilacionMecanica === null) {
                      isvalid_setVentilacionMecanica(true);
                    }
                    if (Malformacion == null) {
                      isvalid_setMalformacion(true);
                    }
                    if (!CualMalformacion && Malformacion == 1) {
                      isvalid_setCualMalformacion(true);
                    }
                    if (CrisisConvulsivas == null) {
                      isvalid_setCrisisConvulsivas(true);
                    }
                    if (TomadoMedicamentos == null) {
                      isvalid_setTomadoMedicamentos(true);
                    }
                    if (!CualesMedicamentos && TomadoMedicamentos == 1) {
                      isvalid_setCualesMedicamentos(true);
                    }
                    if (GolpesCabeza == null) {
                      isvalid_setGolpesCabeza(true);
                    }
                    if (!EspecifiqueGolpes && GolpesCabeza == 1) {
                      isvalid_setEspecifiqueGolpes(true);
                    }
                    if (TamizNeoMetabolico == null) {
                      isvalid_setTamizNeoMetabolico(true);
                    }
                    if (!ResTamizNeoMetabolico && TamizNeoMetabolico == 1) {
                      isvalid_setResTamizNeoMetabolico(true);
                    }
                    if (TamizNeoAuditivo == null) {
                      isvalid_setTamizNeoAuditivo(true);
                    }
                    if (!ResTamizNeoAuditivo && TamizNeoAuditivo == 1) {
                      isvalid_setResTamizNeoAuditivo(true);
                    }
                    if (TamizNeoVisual == null) {
                      isvalid_setTamizNeoVisual(true);
                    }
                    if (!ResTamizNeoVisual && TamizNeoVisual == 1) {
                      isvalid_setResTamizNeoVisual(true);
                    }
                    if (TamizNeoCardiaco == null) {
                      isvalid_setTamizNeoCardiaco(true);
                    }
                  }}
                  onChange={(e) => {
                    if (TamizNeoCardiaco != null && TamizNeoCardiaco == "1") {
                      setResTamizNeoCardiaco(e.target.value);
                    }
                  }}
                  onBlur={() => {
                    if (
                      !ResTamizNeoCardiaco &&
                      TamizNeoCardiaco != null &&
                      TamizNeoCardiaco == "1"
                    ) {
                      isvalid_setResTamizNeoCardiaco(true);
                    }
                  }}
                  size="small"
                  style={{ marginBottom: "1rem" }}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        {/* Medicamentos actuales */}
        <Grid container spacing={2}>
          <Grid item xs={12} md={3} lg={3}>
            <MDBox textAlign="right">
              <MDTypography variant="h6" color="white" style={{ opacity: 0.7, fontSize: "0.9rem" }}>
                Medicamentos que toma actualmente
              </MDTypography>
            </MDBox>
          </Grid>
          <Grid item xs={12} md={9} lg={9}>
            <TextField
              fullWidth
              variant="outlined"
              label="Escriba aquí"
              disabled={desactivar}
              autoComplete="off"
              value={MedicamentosActuales}
              onChange={(e) => setMedicamentosActuales(e.target.value)}
              error={isvalid_MedicamentosActuales}
              helperText={isvalid_MedicamentosActuales ? "Campo obligatorio *" : ""}
              onFocus={() => {
                isvalid_setMedicamentosActuales(false);
                if (TuvoMeningitis == null) {
                  isvalid_setTuvoMeningitis(true);
                }
                if (VentilacionMecanica === null) {
                  isvalid_setVentilacionMecanica(true);
                }
                if (Malformacion == null) {
                  isvalid_setMalformacion(true);
                }
                if (!CualMalformacion && Malformacion == 1) {
                  isvalid_setCualMalformacion(true);
                }
                if (CrisisConvulsivas == null) {
                  isvalid_setCrisisConvulsivas(true);
                }
                if (TomadoMedicamentos == null) {
                  isvalid_setTomadoMedicamentos(true);
                }
                if (!CualesMedicamentos && TomadoMedicamentos == 1) {
                  isvalid_setCualesMedicamentos(true);
                }
                if (GolpesCabeza == null) {
                  isvalid_setGolpesCabeza(true);
                }
                if (!EspecifiqueGolpes && GolpesCabeza == 1) {
                  isvalid_setEspecifiqueGolpes(true);
                }
                if (TamizNeoMetabolico == null) {
                  isvalid_setTamizNeoMetabolico(true);
                }
                if (!ResTamizNeoMetabolico && TamizNeoMetabolico == 1) {
                  isvalid_setResTamizNeoMetabolico(true);
                }
                if (TamizNeoAuditivo == null) {
                  isvalid_setTamizNeoAuditivo(true);
                }
                if (!ResTamizNeoAuditivo && TamizNeoAuditivo == 1) {
                  isvalid_setResTamizNeoAuditivo(true);
                }
                if (TamizNeoVisual == null) {
                  isvalid_setTamizNeoVisual(true);
                }
                if (!ResTamizNeoVisual && TamizNeoVisual == 1) {
                  isvalid_setResTamizNeoVisual(true);
                }
                if (TamizNeoCardiaco == null) {
                  isvalid_setTamizNeoCardiaco(true);
                }
                if (!ResTamizNeoCardiaco && TamizNeoCardiaco == 1) {
                  isvalid_setResTamizNeoCardiaco(true);
                }
              }}
              onBlur={() => {
                if (MedicamentosActuales == null) isvalid_setMedicamentosActuales(false);
              }}
              size="small"
              style={{ marginBottom: "1rem" }}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
        </Grid>

        {/* InfeccionesOido + EspecifiqueInfeccionesOido */}
        <Grid container spacing={2}>
          <Grid item xs={12} md={3} lg={3}>
            <MDBox textAlign="right">
              <MDTypography variant="h6" color="white" style={{ opacity: 0.7, fontSize: "0.9rem" }}>
                ¿Ha tenido infecciones en el oído?
              </MDTypography>
            </MDBox>
          </Grid>
          <Grid item xs={12} md={9} lg={9}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={4} lg={4}>
                <Autocomplete
                  options={[
                    { label: "Sí", value: "1" },
                    { label: "No", value: "0" },
                  ]}
                  getOptionLabel={(option) => option.label}
                  disabled={desactivar}
                  id="InfeccionesOido"
                  value={
                    [
                      { label: "Sí", value: "1" },
                      { label: "No", value: "0" },
                    ].find((opt) => opt.value == InfeccionesOido) || null
                  }
                  onChange={(event, newValue) => {
                    setInfeccionesOido(newValue ? newValue.value : null);
                    if (newValue != null && newValue.value == "1") {
                      isvalid_setEspecifiqueInfeccionesOido(true);
                    } else {
                      isvalid_setEspecifiqueInfeccionesOido(false);
                      setEspecifiqueInfeccionesOido("");
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      autoComplete="new-password"
                      label="Seleccione"
                      variant="outlined"
                      error={isvalid_InfeccionesOido}
                      helperText={isvalid_InfeccionesOido ? "Campo obligatorio *" : ""}
                      onFocus={() => {
                        isvalid_setInfeccionesOido(false);
                        if (TuvoMeningitis == null) {
                          isvalid_setTuvoMeningitis(true);
                        }
                        if (VentilacionMecanica === null) {
                          isvalid_setVentilacionMecanica(true);
                        }
                        if (Malformacion == null) {
                          isvalid_setMalformacion(true);
                        }
                        if (!CualMalformacion && Malformacion == 1) {
                          isvalid_setCualMalformacion(true);
                        }
                        if (CrisisConvulsivas == null) {
                          isvalid_setCrisisConvulsivas(true);
                        }
                        if (TomadoMedicamentos == null) {
                          isvalid_setTomadoMedicamentos(true);
                        }
                        if (!CualesMedicamentos && TomadoMedicamentos == 1) {
                          isvalid_setCualesMedicamentos(true);
                        }
                        if (GolpesCabeza == null) {
                          isvalid_setGolpesCabeza(true);
                        }
                        if (!EspecifiqueGolpes && GolpesCabeza == 1) {
                          isvalid_setEspecifiqueGolpes(true);
                        }
                        if (TamizNeoMetabolico == null) {
                          isvalid_setTamizNeoMetabolico(true);
                        }
                        if (!ResTamizNeoMetabolico && TamizNeoMetabolico == 1) {
                          isvalid_setResTamizNeoMetabolico(true);
                        }
                        if (TamizNeoAuditivo == null) {
                          isvalid_setTamizNeoAuditivo(true);
                        }
                        if (!ResTamizNeoAuditivo && TamizNeoAuditivo == 1) {
                          isvalid_setResTamizNeoAuditivo(true);
                        }
                        if (TamizNeoVisual == null) {
                          isvalid_setTamizNeoVisual(true);
                        }
                        if (!ResTamizNeoVisual && TamizNeoVisual == 1) {
                          isvalid_setResTamizNeoVisual(true);
                        }
                        if (TamizNeoCardiaco == null) {
                          isvalid_setTamizNeoCardiaco(true);
                        }
                        if (!ResTamizNeoCardiaco && TamizNeoCardiaco == 1) {
                          isvalid_setResTamizNeoCardiaco(true);
                        }
                        if (!MedicamentosActuales) {
                          isvalid_setMedicamentosActuales(true);
                        }
                      }}
                      onBlur={() => {
                        if (InfeccionesOido == null) isvalid_setInfeccionesOido(true);
                      }}
                    />
                  )}
                  style={{ width: "100%", marginBottom: "1rem" }}
                  size="small"
                />
              </Grid>

              <Grid item xs={12} md={8} lg={8}>
                <TextField
                  fullWidth
                  variant="outlined"
                  label="Especifique"
                  disabled={desactivar}
                  value={EspecifiqueInfeccionesOido}
                  error={isvalid_EspecifiqueInfeccionesOido}
                  helperText={isvalid_EspecifiqueInfeccionesOido ? "Campo obligatorio *" : ""}
                  onFocus={() => {
                    isvalid_setEspecifiqueInfeccionesOido(false);
                    if (TuvoMeningitis == null) {
                      isvalid_setTuvoMeningitis(true);
                    }
                    if (VentilacionMecanica === null) {
                      isvalid_setVentilacionMecanica(true);
                    }
                    if (Malformacion == null) {
                      isvalid_setMalformacion(true);
                    }
                    if (!CualMalformacion && Malformacion == 1) {
                      isvalid_setCualMalformacion(true);
                    }
                    if (CrisisConvulsivas == null) {
                      isvalid_setCrisisConvulsivas(true);
                    }
                    if (TomadoMedicamentos == null) {
                      isvalid_setTomadoMedicamentos(true);
                    }
                    if (!CualesMedicamentos && TomadoMedicamentos == 1) {
                      isvalid_setCualesMedicamentos(true);
                    }
                    if (GolpesCabeza == null) {
                      isvalid_setGolpesCabeza(true);
                    }
                    if (!EspecifiqueGolpes && GolpesCabeza == 1) {
                      isvalid_setEspecifiqueGolpes(true);
                    }
                    if (TamizNeoMetabolico == null) {
                      isvalid_setTamizNeoMetabolico(true);
                    }
                    if (!ResTamizNeoMetabolico && TamizNeoMetabolico == 1) {
                      isvalid_setResTamizNeoMetabolico(true);
                    }
                    if (TamizNeoAuditivo == null) {
                      isvalid_setTamizNeoAuditivo(true);
                    }
                    if (!ResTamizNeoAuditivo && TamizNeoAuditivo == 1) {
                      isvalid_setResTamizNeoAuditivo(true);
                    }
                    if (TamizNeoVisual == null) {
                      isvalid_setTamizNeoVisual(true);
                    }
                    if (!ResTamizNeoVisual && TamizNeoVisual == 1) {
                      isvalid_setResTamizNeoVisual(true);
                    }
                    if (TamizNeoCardiaco == null) {
                      isvalid_setTamizNeoCardiaco(true);
                    }
                    if (!ResTamizNeoCardiaco && TamizNeoCardiaco == 1) {
                      isvalid_setResTamizNeoCardiaco(true);
                    }
                    if (!MedicamentosActuales) {
                      isvalid_setMedicamentosActuales(true);
                    }
                    if (InfeccionesOido == null) {
                      isvalid_setInfeccionesOido(true);
                    }
                  }}
                  onChange={(e) => {
                    if (InfeccionesOido != null && InfeccionesOido == "1") {
                      setEspecifiqueInfeccionesOido(e.target.value);
                    }
                  }}
                  onBlur={() => {
                    if (
                      !EspecifiqueInfeccionesOido &&
                      InfeccionesOido != null &&
                      InfeccionesOido == "1"
                    ) {
                      isvalid_setEspecifiqueInfeccionesOido(true);
                    }
                  }}
                  size="small"
                  style={{ marginBottom: "1rem" }}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        {/* InfeccionesGarganta + Ronca */}
        <Grid container spacing={2}>
          <Grid item xs={12} md={3} lg={3}>
            <MDBox textAlign="right">
              <MDTypography variant="h6" color="white" style={{ opacity: 0.7, fontSize: "0.9rem" }}>
                ¿Infecciones en garganta recurrentes? (más de 6 por año)
              </MDTypography>
            </MDBox>
          </Grid>
          <Grid item xs={12} md={9} lg={9}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={6} lg={6}>
                <Autocomplete
                  options={[
                    { label: "Sí", value: "1" },
                    { label: "No", value: "0" },
                  ]}
                  getOptionLabel={(option) => option.label}
                  disabled={desactivar}
                  id="InfeccionesGarganta"
                  value={
                    [
                      { label: "Sí", value: "1" },
                      { label: "No", value: "0" },
                    ].find((opt) => opt.value == InfeccionesGarganta) || null
                  }
                  onChange={(event, newValue) =>
                    setInfeccionesGarganta(newValue ? newValue.value : null)
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      autoComplete="new-password"
                      label="Seleccione"
                      variant="outlined"
                      error={isvalid_InfeccionesGarganta}
                      helperText={isvalid_InfeccionesGarganta ? "Campo obligatorio *" : ""}
                      onFocus={() => {
                        isvalid_setInfeccionesGarganta(false);
                        if (TuvoMeningitis == null) {
                          isvalid_setTuvoMeningitis(true);
                        }
                        if (VentilacionMecanica === null) {
                          isvalid_setVentilacionMecanica(true);
                        }
                        if (Malformacion == null) {
                          isvalid_setMalformacion(true);
                        }
                        if (!CualMalformacion && Malformacion == 1) {
                          isvalid_setCualMalformacion(true);
                        }
                        if (CrisisConvulsivas == null) {
                          isvalid_setCrisisConvulsivas(true);
                        }
                        if (TomadoMedicamentos == null) {
                          isvalid_setTomadoMedicamentos(true);
                        }
                        if (!CualesMedicamentos && TomadoMedicamentos == 1) {
                          isvalid_setCualesMedicamentos(true);
                        }
                        if (GolpesCabeza == null) {
                          isvalid_setGolpesCabeza(true);
                        }
                        if (!EspecifiqueGolpes && GolpesCabeza == 1) {
                          isvalid_setEspecifiqueGolpes(true);
                        }
                        if (TamizNeoMetabolico == null) {
                          isvalid_setTamizNeoMetabolico(true);
                        }
                        if (!ResTamizNeoMetabolico && TamizNeoMetabolico == 1) {
                          isvalid_setResTamizNeoMetabolico(true);
                        }
                        if (TamizNeoAuditivo == null) {
                          isvalid_setTamizNeoAuditivo(true);
                        }
                        if (!ResTamizNeoAuditivo && TamizNeoAuditivo == 1) {
                          isvalid_setResTamizNeoAuditivo(true);
                        }
                        if (TamizNeoVisual == null) {
                          isvalid_setTamizNeoVisual(true);
                        }
                        if (!ResTamizNeoVisual && TamizNeoVisual == 1) {
                          isvalid_setResTamizNeoVisual(true);
                        }
                        if (TamizNeoCardiaco == null) {
                          isvalid_setTamizNeoCardiaco(true);
                        }
                        if (!ResTamizNeoCardiaco && TamizNeoCardiaco == 1) {
                          isvalid_setResTamizNeoCardiaco(true);
                        }
                        if (!MedicamentosActuales) {
                          isvalid_setMedicamentosActuales(true);
                        }
                        if (InfeccionesOido == null) {
                          isvalid_setInfeccionesOido(true);
                        }
                        if (!EspecifiqueInfeccionesOido && InfeccionesOido == 1) {
                          isvalid_setEspecifiqueInfeccionesOido(true);
                        }
                      }}
                      onBlur={() => {
                        if (InfeccionesGarganta == null) isvalid_setInfeccionesGarganta(true);
                      }}
                    />
                  )}
                  style={{ width: "100%", marginBottom: "1rem" }}
                  size="small"
                />
              </Grid>
              <Grid item xs={12} md={6} lg={6}>
                <Autocomplete
                  options={[
                    { label: "Sí", value: "1" },
                    { label: "No", value: "0" },
                  ]}
                  getOptionLabel={(option) => option.label}
                  disabled={desactivar}
                  id="Ronca"
                  value={
                    [
                      { label: "Sí", value: "1" },
                      { label: "No", value: "0" },
                    ].find((opt) => opt.value == Ronca) || null
                  }
                  onChange={(event, newValue) => setRonca(newValue ? newValue.value : null)}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      autoComplete="new-password"
                      label="¿Ronca?"
                      variant="outlined"
                      error={isvalid_Ronca}
                      helperText={isvalid_Ronca ? "Campo obligatorio *" : ""}
                      onFocus={() => {
                        isvalid_setRonca(false);
                        if (TuvoMeningitis == null) {
                          isvalid_setTuvoMeningitis(true);
                        }
                        if (VentilacionMecanica === null) {
                          isvalid_setVentilacionMecanica(true);
                        }
                        if (Malformacion == null) {
                          isvalid_setMalformacion(true);
                        }
                        if (!CualMalformacion && Malformacion == 1) {
                          isvalid_setCualMalformacion(true);
                        }
                        if (CrisisConvulsivas == null) {
                          isvalid_setCrisisConvulsivas(true);
                        }
                        if (TomadoMedicamentos == null) {
                          isvalid_setTomadoMedicamentos(true);
                        }
                        if (!CualesMedicamentos && TomadoMedicamentos == 1) {
                          isvalid_setCualesMedicamentos(true);
                        }
                        if (GolpesCabeza == null) {
                          isvalid_setGolpesCabeza(true);
                        }
                        if (!EspecifiqueGolpes && GolpesCabeza == 1) {
                          isvalid_setEspecifiqueGolpes(true);
                        }
                        if (TamizNeoMetabolico == null) {
                          isvalid_setTamizNeoMetabolico(true);
                        }
                        if (!ResTamizNeoMetabolico && TamizNeoMetabolico == 1) {
                          isvalid_setResTamizNeoMetabolico(true);
                        }
                        if (TamizNeoAuditivo == null) {
                          isvalid_setTamizNeoAuditivo(true);
                        }
                        if (!ResTamizNeoAuditivo && TamizNeoAuditivo == 1) {
                          isvalid_setResTamizNeoAuditivo(true);
                        }
                        if (TamizNeoVisual == null) {
                          isvalid_setTamizNeoVisual(true);
                        }
                        if (!ResTamizNeoVisual && TamizNeoVisual == 1) {
                          isvalid_setResTamizNeoVisual(true);
                        }
                        if (TamizNeoCardiaco == null) {
                          isvalid_setTamizNeoCardiaco(true);
                        }
                        if (!ResTamizNeoCardiaco && TamizNeoCardiaco == 1) {
                          isvalid_setResTamizNeoCardiaco(true);
                        }
                        if (!MedicamentosActuales) {
                          isvalid_setMedicamentosActuales(true);
                        }
                        if (InfeccionesOido == null) {
                          isvalid_setInfeccionesOido(true);
                        }
                        if (!EspecifiqueInfeccionesOido && InfeccionesOido == 1) {
                          isvalid_setEspecifiqueInfeccionesOido(true);
                        }
                        if (InfeccionesGarganta == null) {
                          isvalid_setInfeccionesGarganta(true);
                        }
                      }}
                      onBlur={() => {
                        if (Ronca == null) isvalid_setRonca(true);
                      }}
                    />
                  )}
                  style={{ width: "100%", marginBottom: "1rem" }}
                  size="small"
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        {/* TieneCirugias + EspecifiqueCirugias */}
        <Grid container spacing={2}>
          <Grid item xs={12} md={3} lg={3}>
            <MDBox textAlign="right">
              <MDTypography variant="h6" color="white" style={{ opacity: 0.7, fontSize: "0.9rem" }}>
                ¿Ha tenido cirugías?
              </MDTypography>
            </MDBox>
          </Grid>
          <Grid item xs={12} md={9} lg={9}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={4} lg={4}>
                <Autocomplete
                  options={[
                    { label: "Sí", value: "1" },
                    { label: "No", value: "0" },
                  ]}
                  getOptionLabel={(option) => option.label}
                  disabled={desactivar}
                  id="TieneCirugias"
                  value={
                    [
                      { label: "Sí", value: "1" },
                      { label: "No", value: "0" },
                    ].find((opt) => opt.value == TieneCirugias) || null
                  }
                  onChange={(event, newValue) => {
                    setTieneCirugias(newValue ? newValue.value : null);
                    if (newValue != null && newValue.value == "1") {
                      isvalid_setEspecifiqueCirugias(true);
                    } else {
                      isvalid_setEspecifiqueCirugias(false);
                      setEspecifiqueCirugias("");
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      autoComplete="new-password"
                      label="Seleccione"
                      variant="outlined"
                      error={isvalid_TieneCirugias}
                      helperText={isvalid_TieneCirugias ? "Campo obligatorio *" : ""}
                      onFocus={() => {
                        isvalid_setTieneCirugias(false);
                        if (TuvoMeningitis == null) {
                          isvalid_setTuvoMeningitis(true);
                        }
                        if (VentilacionMecanica === null) {
                          isvalid_setVentilacionMecanica(true);
                        }
                        if (Malformacion == null) {
                          isvalid_setMalformacion(true);
                        }
                        if (!CualMalformacion && Malformacion == 1) {
                          isvalid_setCualMalformacion(true);
                        }
                        if (CrisisConvulsivas == null) {
                          isvalid_setCrisisConvulsivas(true);
                        }
                        if (TomadoMedicamentos == null) {
                          isvalid_setTomadoMedicamentos(true);
                        }
                        if (!CualesMedicamentos && TomadoMedicamentos == 1) {
                          isvalid_setCualesMedicamentos(true);
                        }
                        if (GolpesCabeza == null) {
                          isvalid_setGolpesCabeza(true);
                        }
                        if (!EspecifiqueGolpes && GolpesCabeza == 1) {
                          isvalid_setEspecifiqueGolpes(true);
                        }
                        if (TamizNeoMetabolico == null) {
                          isvalid_setTamizNeoMetabolico(true);
                        }
                        if (!ResTamizNeoMetabolico && TamizNeoMetabolico == 1) {
                          isvalid_setResTamizNeoMetabolico(true);
                        }
                        if (TamizNeoAuditivo == null) {
                          isvalid_setTamizNeoAuditivo(true);
                        }
                        if (!ResTamizNeoAuditivo && TamizNeoAuditivo == 1) {
                          isvalid_setResTamizNeoAuditivo(true);
                        }
                        if (TamizNeoVisual == null) {
                          isvalid_setTamizNeoVisual(true);
                        }
                        if (!ResTamizNeoVisual && TamizNeoVisual == 1) {
                          isvalid_setResTamizNeoVisual(true);
                        }
                        if (TamizNeoCardiaco == null) {
                          isvalid_setTamizNeoCardiaco(true);
                        }
                        if (!ResTamizNeoCardiaco && TamizNeoCardiaco == 1) {
                          isvalid_setResTamizNeoCardiaco(true);
                        }
                        if (!MedicamentosActuales) {
                          isvalid_setMedicamentosActuales(true);
                        }
                        if (InfeccionesOido == null) {
                          isvalid_setInfeccionesOido(true);
                        }
                        if (!EspecifiqueInfeccionesOido && InfeccionesOido == 1) {
                          isvalid_setEspecifiqueInfeccionesOido(true);
                        }
                        if (InfeccionesGarganta == null) {
                          isvalid_setInfeccionesGarganta(true);
                        }
                        if (Ronca == null) {
                          isvalid_setRonca(true);
                        }
                      }}
                      onBlur={() => {
                        if (TieneCirugias == null) isvalid_setTieneCirugias(true);
                      }}
                    />
                  )}
                  style={{ width: "100%", marginBottom: "1rem" }}
                  size="small"
                />
              </Grid>
              <Grid item xs={12} md={8} lg={8}>
                <TextField
                  fullWidth
                  variant="outlined"
                  label="Especifique"
                  disabled={desactivar}
                  value={EspecifiqueCirugias}
                  error={isvalid_EspecifiqueCirugias}
                  helperText={isvalid_EspecifiqueCirugias ? "Campo obligatorio *" : ""}
                  onFocus={() => {
                    isvalid_setEspecifiqueCirugias(false);
                    if (TuvoMeningitis == null) {
                      isvalid_setTuvoMeningitis(true);
                    }
                    if (VentilacionMecanica === null) {
                      isvalid_setVentilacionMecanica(true);
                    }
                    if (Malformacion == null) {
                      isvalid_setMalformacion(true);
                    }
                    if (!CualMalformacion && Malformacion == 1) {
                      isvalid_setCualMalformacion(true);
                    }
                    if (CrisisConvulsivas == null) {
                      isvalid_setCrisisConvulsivas(true);
                    }
                    if (TomadoMedicamentos == null) {
                      isvalid_setTomadoMedicamentos(true);
                    }
                    if (!CualesMedicamentos && TomadoMedicamentos == 1) {
                      isvalid_setCualesMedicamentos(true);
                    }
                    if (GolpesCabeza == null) {
                      isvalid_setGolpesCabeza(true);
                    }
                    if (!EspecifiqueGolpes && GolpesCabeza == 1) {
                      isvalid_setEspecifiqueGolpes(true);
                    }
                    if (TamizNeoMetabolico == null) {
                      isvalid_setTamizNeoMetabolico(true);
                    }
                    if (!ResTamizNeoMetabolico && TamizNeoMetabolico == 1) {
                      isvalid_setResTamizNeoMetabolico(true);
                    }
                    if (TamizNeoAuditivo == null) {
                      isvalid_setTamizNeoAuditivo(true);
                    }
                    if (!ResTamizNeoAuditivo && TamizNeoAuditivo == 1) {
                      isvalid_setResTamizNeoAuditivo(true);
                    }
                    if (TamizNeoVisual == null) {
                      isvalid_setTamizNeoVisual(true);
                    }
                    if (!ResTamizNeoVisual && TamizNeoVisual == 1) {
                      isvalid_setResTamizNeoVisual(true);
                    }
                    if (TamizNeoCardiaco == null) {
                      isvalid_setTamizNeoCardiaco(true);
                    }
                    if (!ResTamizNeoCardiaco && TamizNeoCardiaco == 1) {
                      isvalid_setResTamizNeoCardiaco(true);
                    }
                    if (!MedicamentosActuales) {
                      isvalid_setMedicamentosActuales(true);
                    }
                    if (InfeccionesOido == null) {
                      isvalid_setInfeccionesOido(true);
                    }
                    if (!EspecifiqueInfeccionesOido && InfeccionesOido == 1) {
                      isvalid_setEspecifiqueInfeccionesOido(true);
                    }
                    if (InfeccionesGarganta == null) {
                      isvalid_setInfeccionesGarganta(true);
                    }
                    if (Ronca == null) {
                      isvalid_setRonca(true);
                    }
                    if (TieneCirugias == null) {
                      isvalid_setTieneCirugias(true);
                    }
                  }}
                  onChange={(e) => {
                    if (TieneCirugias != null && TieneCirugias == "1") {
                      setEspecifiqueCirugias(e.target.value);
                    }
                  }}
                  onBlur={() => {
                    if (!EspecifiqueCirugias && TieneCirugias != null && TieneCirugias == "1") {
                      isvalid_setEspecifiqueCirugias(true);
                    }
                  }}
                  size="small"
                  style={{ marginBottom: "1rem" }}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        {/* ProblemaAlimentacion + EspecifiqueProbAlimenta */}
        <Grid container spacing={2}>
          <Grid item xs={12} md={3} lg={3}>
            <MDBox textAlign="right">
              <MDTypography variant="h6" color="white" style={{ opacity: 0.7, fontSize: "0.9rem" }}>
                ¿Problemas de Alimentación?
              </MDTypography>
            </MDBox>
          </Grid>
          <Grid item xs={12} md={9} lg={9}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={4} lg={4}>
                <Autocomplete
                  options={[
                    { label: "Sí", value: "1" },
                    { label: "No", value: "0" },
                  ]}
                  getOptionLabel={(option) => option.label}
                  disabled={desactivar}
                  id="ProblemaAlimentacion"
                  value={
                    [
                      { label: "Sí", value: "1" },
                      { label: "No", value: "0" },
                    ].find((opt) => opt.value == ProblemaAlimentacion) || null
                  }
                  onChange={(event, newValue) => {
                    setProblemaAlimentacion(newValue ? newValue.value : null);
                    if (newValue != null && newValue.value == "1") {
                      isvalid_setEspecifiqueProbAlimenta(true);
                    } else {
                      isvalid_setEspecifiqueProbAlimenta(false);
                      setEspecifiqueProbAlimenta("");
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      autoComplete="new-password"
                      label="Seleccione"
                      variant="outlined"
                      error={isvalid_ProblemaAlimentacion}
                      helperText={isvalid_ProblemaAlimentacion ? "Campo obligatorio *" : ""}
                      onFocus={() => {
                        isvalid_setProblemaAlimentacion(false);
                        if (TuvoMeningitis == null) {
                          isvalid_setTuvoMeningitis(true);
                        }
                        if (VentilacionMecanica === null) {
                          isvalid_setVentilacionMecanica(true);
                        }
                        if (Malformacion == null) {
                          isvalid_setMalformacion(true);
                        }
                        if (!CualMalformacion && Malformacion == 1) {
                          isvalid_setCualMalformacion(true);
                        }
                        if (CrisisConvulsivas == null) {
                          isvalid_setCrisisConvulsivas(true);
                        }
                        if (TomadoMedicamentos == null) {
                          isvalid_setTomadoMedicamentos(true);
                        }
                        if (!CualesMedicamentos && TomadoMedicamentos == 1) {
                          isvalid_setCualesMedicamentos(true);
                        }
                        if (GolpesCabeza == null) {
                          isvalid_setGolpesCabeza(true);
                        }
                        if (!EspecifiqueGolpes && GolpesCabeza == 1) {
                          isvalid_setEspecifiqueGolpes(true);
                        }
                        if (TamizNeoMetabolico == null) {
                          isvalid_setTamizNeoMetabolico(true);
                        }
                        if (!ResTamizNeoMetabolico && TamizNeoMetabolico == 1) {
                          isvalid_setResTamizNeoMetabolico(true);
                        }
                        if (TamizNeoAuditivo == null) {
                          isvalid_setTamizNeoAuditivo(true);
                        }
                        if (!ResTamizNeoAuditivo && TamizNeoAuditivo == 1) {
                          isvalid_setResTamizNeoAuditivo(true);
                        }
                        if (TamizNeoVisual == null) {
                          isvalid_setTamizNeoVisual(true);
                        }
                        if (!ResTamizNeoVisual && TamizNeoVisual == 1) {
                          isvalid_setResTamizNeoVisual(true);
                        }
                        if (TamizNeoCardiaco == null) {
                          isvalid_setTamizNeoCardiaco(true);
                        }
                        if (!ResTamizNeoCardiaco && TamizNeoCardiaco == 1) {
                          isvalid_setResTamizNeoCardiaco(true);
                        }
                        if (!MedicamentosActuales) {
                          isvalid_setMedicamentosActuales(true);
                        }
                        if (InfeccionesOido == null) {
                          isvalid_setInfeccionesOido(true);
                        }
                        if (!EspecifiqueInfeccionesOido && InfeccionesOido == 1) {
                          isvalid_setEspecifiqueInfeccionesOido(true);
                        }
                        if (InfeccionesGarganta == null) {
                          isvalid_setInfeccionesGarganta(true);
                        }
                        if (Ronca == null) {
                          isvalid_setRonca(true);
                        }
                        if (TieneCirugias == null) {
                          isvalid_setTieneCirugias(true);
                        }
                        if (!EspecifiqueCirugias && TieneCirugias == 1) {
                          isvalid_setEspecifiqueCirugias(true);
                        }
                      }}
                      onBlur={() => {
                        if (ProblemaAlimentacion == null) isvalid_setProblemaAlimentacion(true);
                      }}
                    />
                  )}
                  style={{ width: "100%", marginBottom: "1rem" }}
                  size="small"
                />
              </Grid>
              <Grid item xs={12} md={8} lg={8}>
                <TextField
                  fullWidth
                  variant="outlined"
                  label="Especifique"
                  disabled={desactivar}
                  value={EspecifiqueProbAlimenta}
                  error={isvalid_EspecifiqueProbAlimenta}
                  helperText={isvalid_EspecifiqueProbAlimenta ? "Campo obligatorio *" : ""}
                  onChange={(e) => {
                    if (ProblemaAlimentacion != null && ProblemaAlimentacion == "1") {
                      setEspecifiqueProbAlimenta(e.target.value);
                    }
                  }}
                  onFocus={() => {
                    isvalid_setEspecifiqueProbAlimenta(false);
                    if (TuvoMeningitis == null) {
                      isvalid_setTuvoMeningitis(true);
                    }
                    if (VentilacionMecanica === null) {
                      isvalid_setVentilacionMecanica(true);
                    }
                    if (Malformacion == null) {
                      isvalid_setMalformacion(true);
                    }
                    if (!CualMalformacion && Malformacion == 1) {
                      isvalid_setCualMalformacion(true);
                    }
                    if (CrisisConvulsivas == null) {
                      isvalid_setCrisisConvulsivas(true);
                    }
                    if (TomadoMedicamentos == null) {
                      isvalid_setTomadoMedicamentos(true);
                    }
                    if (!CualesMedicamentos && TomadoMedicamentos == 1) {
                      isvalid_setCualesMedicamentos(true);
                    }
                    if (GolpesCabeza == null) {
                      isvalid_setGolpesCabeza(true);
                    }
                    if (!EspecifiqueGolpes && GolpesCabeza == 1) {
                      isvalid_setEspecifiqueGolpes(true);
                    }
                    if (TamizNeoMetabolico == null) {
                      isvalid_setTamizNeoMetabolico(true);
                    }
                    if (!ResTamizNeoMetabolico && TamizNeoMetabolico == 1) {
                      isvalid_setResTamizNeoMetabolico(true);
                    }
                    if (TamizNeoAuditivo == null) {
                      isvalid_setTamizNeoAuditivo(true);
                    }
                    if (!ResTamizNeoAuditivo && TamizNeoAuditivo == 1) {
                      isvalid_setResTamizNeoAuditivo(true);
                    }
                    if (TamizNeoVisual == null) {
                      isvalid_setTamizNeoVisual(true);
                    }
                    if (!ResTamizNeoVisual && TamizNeoVisual == 1) {
                      isvalid_setResTamizNeoVisual(true);
                    }
                    if (TamizNeoCardiaco == null) {
                      isvalid_setTamizNeoCardiaco(true);
                    }
                    if (!ResTamizNeoCardiaco && TamizNeoCardiaco == 1) {
                      isvalid_setResTamizNeoCardiaco(true);
                    }
                    if (!MedicamentosActuales) {
                      isvalid_setMedicamentosActuales(true);
                    }
                    if (InfeccionesOido == null) {
                      isvalid_setInfeccionesOido(true);
                    }
                    if (!EspecifiqueInfeccionesOido && InfeccionesOido == 1) {
                      isvalid_setEspecifiqueInfeccionesOido(true);
                    }
                    if (InfeccionesGarganta == null) {
                      isvalid_setInfeccionesGarganta(true);
                    }
                    if (Ronca == null) {
                      isvalid_setRonca(true);
                    }
                    if (TieneCirugias == null) {
                      isvalid_setTieneCirugias(true);
                    }
                    if (!EspecifiqueCirugias && TieneCirugias == 1) {
                      isvalid_setEspecifiqueCirugias(true);
                    }
                    if (ProblemaAlimentacion == null) {
                      isvalid_setProblemaAlimentacion(true);
                    }
                  }}
                  onBlur={() => {
                    if (
                      !EspecifiqueProbAlimenta &&
                      ProblemaAlimentacion != null &&
                      ProblemaAlimentacion == "1"
                    ) {
                      isvalid_setEspecifiqueProbAlimenta(true);
                    }
                  }}
                  size="small"
                  style={{ marginBottom: "1rem" }}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        {/* Hospitalizado */}
        <Grid container spacing={2}>
          <Grid item xs={12} md={3} lg={3}>
            <MDBox textAlign="right">
              <MDTypography variant="h6" color="white" style={{ opacity: 0.7, fontSize: "0.9rem" }}>
                ¿Ha estado hospitalizado?
              </MDTypography>
            </MDBox>
          </Grid>
          <Grid item xs={12} md={9} lg={9}>
            <Autocomplete
              options={[
                { label: "Sí", value: "1" },
                { label: "No", value: "0" },
              ]}
              getOptionLabel={(option) => option.label}
              disabled={desactivar}
              id="Hospitalizado"
              value={
                [
                  { label: "Sí", value: "1" },
                  { label: "No", value: "0" },
                ].find((opt) => opt.value == Hospitalizado) || null
              }
              onChange={(event, newValue) => setHospitalizado(newValue ? newValue.value : null)}
              renderInput={(params) => (
                <TextField
                  {...params}
                  autoComplete="new-password"
                  label="Seleccione"
                  variant="outlined"
                  error={isvalid_Hospitalizado}
                  helperText={isvalid_Hospitalizado ? "Campo obligatorio *" : ""}
                  onFocus={() => {
                    isvalid_setHospitalizado(false);
                    if (TuvoMeningitis == null) {
                      isvalid_setTuvoMeningitis(true);
                    }
                    if (VentilacionMecanica === null) {
                      isvalid_setVentilacionMecanica(true);
                    }
                    if (Malformacion == null) {
                      isvalid_setMalformacion(true);
                    }
                    if (!CualMalformacion && Malformacion == 1) {
                      isvalid_setCualMalformacion(true);
                    }
                    if (CrisisConvulsivas == null) {
                      isvalid_setCrisisConvulsivas(true);
                    }
                    if (TomadoMedicamentos == null) {
                      isvalid_setTomadoMedicamentos(true);
                    }
                    if (!CualesMedicamentos && TomadoMedicamentos == 1) {
                      isvalid_setCualesMedicamentos(true);
                    }
                    if (GolpesCabeza == null) {
                      isvalid_setGolpesCabeza(true);
                    }
                    if (!EspecifiqueGolpes && GolpesCabeza == 1) {
                      isvalid_setEspecifiqueGolpes(true);
                    }
                    if (TamizNeoMetabolico == null) {
                      isvalid_setTamizNeoMetabolico(true);
                    }
                    if (!ResTamizNeoMetabolico && TamizNeoMetabolico == 1) {
                      isvalid_setResTamizNeoMetabolico(true);
                    }
                    if (TamizNeoAuditivo == null) {
                      isvalid_setTamizNeoAuditivo(true);
                    }
                    if (!ResTamizNeoAuditivo && TamizNeoAuditivo == 1) {
                      isvalid_setResTamizNeoAuditivo(true);
                    }
                    if (TamizNeoVisual == null) {
                      isvalid_setTamizNeoVisual(true);
                    }
                    if (!ResTamizNeoVisual && TamizNeoVisual == 1) {
                      isvalid_setResTamizNeoVisual(true);
                    }
                    if (TamizNeoCardiaco == null) {
                      isvalid_setTamizNeoCardiaco(true);
                    }
                    if (!ResTamizNeoCardiaco && TamizNeoCardiaco == 1) {
                      isvalid_setResTamizNeoCardiaco(true);
                    }
                    if (!MedicamentosActuales) {
                      isvalid_setMedicamentosActuales(true);
                    }
                    if (InfeccionesOido == null) {
                      isvalid_setInfeccionesOido(true);
                    }
                    if (!EspecifiqueInfeccionesOido && InfeccionesOido == 1) {
                      isvalid_setEspecifiqueInfeccionesOido(true);
                    }
                    if (InfeccionesGarganta == null) {
                      isvalid_setInfeccionesGarganta(true);
                    }
                    if (Ronca == null) {
                      isvalid_setRonca(true);
                    }
                    if (TieneCirugias == null) {
                      isvalid_setTieneCirugias(true);
                    }
                    if (!EspecifiqueCirugias && TieneCirugias == 1) {
                      isvalid_setEspecifiqueCirugias(true);
                    }
                    if (ProblemaAlimentacion == null) {
                      isvalid_setProblemaAlimentacion(true);
                    }
                    if (!EspecifiqueProbAlimenta && ProblemaAlimentacion == 1) {
                      isvalid_setEspecifiqueProbAlimenta(true);
                    }
                  }}
                  onBlur={() => {
                    if (Hospitalizado == null) isvalid_setHospitalizado(true);
                  }}
                />
              )}
              style={{ width: "100%", marginBottom: "1rem" }}
              size="small"
            />
          </Grid>
        </Grid>

        {/* IdInfeccionCMV + EspecifiqueInfeccionCMV */}
        <Grid container spacing={2}>
          <Grid item xs={12} md={3} lg={3}>
            <MDBox textAlign="right">
              <MDTypography variant="h6" color="white" style={{ opacity: 0.7, fontSize: "0.9rem" }}>
                ¿Tuvo o sospecha de infección de CMV (citomegalovirus)?
              </MDTypography>
            </MDBox>
          </Grid>
          <Grid item xs={12} md={9} lg={9}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={4} lg={4}>
                <Autocomplete
                  options={[
                    { label: "Sí", value: "1" },
                    { label: "No", value: "0" },
                    { label: "No sé", value: "2" },
                  ]}
                  getOptionLabel={(option) => option.label}
                  disabled={desactivar}
                  id="IdInfeccionCMV"
                  value={
                    [
                      { label: "Sí", value: "1" },
                      { label: "No", value: "0" },
                      { label: "No sé", value: "2" },
                    ].find((opt) => opt.value == IdInfeccionCMV) || null
                  }
                  onChange={(event, newValue) => {
                    setIdInfeccionCMV(newValue ? newValue.value : null);
                    if (newValue != null && newValue.value == "1") {
                      isvalid_setEspecifiqueInfeccionCMV(true);
                    } else {
                      isvalid_setEspecifiqueInfeccionCMV(false);
                      setEspecifiqueInfeccionCMV("");
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      autoComplete="new-password"
                      label="Seleccione"
                      variant="outlined"
                      error={isvalid_IdInfeccionCMV}
                      helperText={isvalid_IdInfeccionCMV ? "Campo obligatorio *" : ""}
                      onFocus={() => {
                        isvalid_setIdInfeccionCMV(false);
                        if (TuvoMeningitis == null) {
                          isvalid_setTuvoMeningitis(true);
                        }
                        if (VentilacionMecanica === null) {
                          isvalid_setVentilacionMecanica(true);
                        }
                        if (Malformacion == null) {
                          isvalid_setMalformacion(true);
                        }
                        if (!CualMalformacion && Malformacion == 1) {
                          isvalid_setCualMalformacion(true);
                        }
                        if (CrisisConvulsivas == null) {
                          isvalid_setCrisisConvulsivas(true);
                        }
                        if (TomadoMedicamentos == null) {
                          isvalid_setTomadoMedicamentos(true);
                        }
                        if (!CualesMedicamentos && TomadoMedicamentos == 1) {
                          isvalid_setCualesMedicamentos(true);
                        }
                        if (GolpesCabeza == null) {
                          isvalid_setGolpesCabeza(true);
                        }
                        if (!EspecifiqueGolpes && GolpesCabeza == 1) {
                          isvalid_setEspecifiqueGolpes(true);
                        }
                        if (TamizNeoMetabolico == null) {
                          isvalid_setTamizNeoMetabolico(true);
                        }
                        if (!ResTamizNeoMetabolico && TamizNeoMetabolico == 1) {
                          isvalid_setResTamizNeoMetabolico(true);
                        }
                        if (TamizNeoAuditivo == null) {
                          isvalid_setTamizNeoAuditivo(true);
                        }
                        if (!ResTamizNeoAuditivo && TamizNeoAuditivo == 1) {
                          isvalid_setResTamizNeoAuditivo(true);
                        }
                        if (TamizNeoVisual == null) {
                          isvalid_setTamizNeoVisual(true);
                        }
                        if (!ResTamizNeoVisual && TamizNeoVisual == 1) {
                          isvalid_setResTamizNeoVisual(true);
                        }
                        if (TamizNeoCardiaco == null) {
                          isvalid_setTamizNeoCardiaco(true);
                        }
                        if (!ResTamizNeoCardiaco && TamizNeoCardiaco == 1) {
                          isvalid_setResTamizNeoCardiaco(true);
                        }
                        if (!MedicamentosActuales) {
                          isvalid_setMedicamentosActuales(true);
                        }
                        if (InfeccionesOido == null) {
                          isvalid_setInfeccionesOido(true);
                        }
                        if (!EspecifiqueInfeccionesOido && InfeccionesOido == 1) {
                          isvalid_setEspecifiqueInfeccionesOido(true);
                        }
                        if (InfeccionesGarganta == null) {
                          isvalid_setInfeccionesGarganta(true);
                        }
                        if (Ronca == null) {
                          isvalid_setRonca(true);
                        }
                        if (TieneCirugias == null) {
                          isvalid_setTieneCirugias(true);
                        }
                        if (!EspecifiqueCirugias && TieneCirugias == 1) {
                          isvalid_setEspecifiqueCirugias(true);
                        }
                        if (ProblemaAlimentacion == null) {
                          isvalid_setProblemaAlimentacion(true);
                        }
                        if (!EspecifiqueProbAlimenta && ProblemaAlimentacion == 1) {
                          isvalid_setEspecifiqueProbAlimenta(true);
                        }
                        if (Hospitalizado == null) {
                          isvalid_setHospitalizado(true);
                        }
                      }}
                      onBlur={() => {
                        if (IdInfeccionCMV == null) isvalid_setIdInfeccionCMV(true);
                      }}
                    />
                  )}
                  style={{ width: "100%", marginBottom: "1rem" }}
                  size="small"
                />
              </Grid>
              <Grid item xs={12} md={8} lg={8}>
                <TextField
                  fullWidth
                  variant="outlined"
                  label="Especifique"
                  disabled={desactivar}
                  value={EspecifiqueInfeccionCMV}
                  error={isvalid_EspecifiqueInfeccionCMV}
                  helperText={isvalid_EspecifiqueInfeccionCMV ? "Campo obligatorio *" : ""}
                  onChange={(e) => {
                    if (IdInfeccionCMV != null && IdInfeccionCMV == "1") {
                      setEspecifiqueInfeccionCMV(e.target.value);
                    }
                  }}
                  onFocus={() => {
                    isvalid_setEspecifiqueInfeccionCMV(false);
                    if (TuvoMeningitis == null) {
                      isvalid_setTuvoMeningitis(true);
                    }
                    if (VentilacionMecanica === null) {
                      isvalid_setVentilacionMecanica(true);
                    }
                    if (Malformacion == null) {
                      isvalid_setMalformacion(true);
                    }
                    if (!CualMalformacion && Malformacion == 1) {
                      isvalid_setCualMalformacion(true);
                    }
                    if (CrisisConvulsivas == null) {
                      isvalid_setCrisisConvulsivas(true);
                    }
                    if (TomadoMedicamentos == null) {
                      isvalid_setTomadoMedicamentos(true);
                    }
                    if (!CualesMedicamentos && TomadoMedicamentos == 1) {
                      isvalid_setCualesMedicamentos(true);
                    }
                    if (GolpesCabeza == null) {
                      isvalid_setGolpesCabeza(true);
                    }
                    if (!EspecifiqueGolpes && GolpesCabeza == 1) {
                      isvalid_setEspecifiqueGolpes(true);
                    }
                    if (TamizNeoMetabolico == null) {
                      isvalid_setTamizNeoMetabolico(true);
                    }
                    if (!ResTamizNeoMetabolico && TamizNeoMetabolico == 1) {
                      isvalid_setResTamizNeoMetabolico(true);
                    }
                    if (TamizNeoAuditivo == null) {
                      isvalid_setTamizNeoAuditivo(true);
                    }
                    if (!ResTamizNeoAuditivo && TamizNeoAuditivo == 1) {
                      isvalid_setResTamizNeoAuditivo(true);
                    }
                    if (TamizNeoVisual == null) {
                      isvalid_setTamizNeoVisual(true);
                    }
                    if (!ResTamizNeoVisual && TamizNeoVisual == 1) {
                      isvalid_setResTamizNeoVisual(true);
                    }
                    if (TamizNeoCardiaco == null) {
                      isvalid_setTamizNeoCardiaco(true);
                    }
                    if (!ResTamizNeoCardiaco && TamizNeoCardiaco == 1) {
                      isvalid_setResTamizNeoCardiaco(true);
                    }
                    if (!MedicamentosActuales) {
                      isvalid_setMedicamentosActuales(true);
                    }
                    if (InfeccionesOido == null) {
                      isvalid_setInfeccionesOido(true);
                    }
                    if (!EspecifiqueInfeccionesOido && InfeccionesOido == 1) {
                      isvalid_setEspecifiqueInfeccionesOido(true);
                    }
                    if (InfeccionesGarganta == null) {
                      isvalid_setInfeccionesGarganta(true);
                    }
                    if (Ronca == null) {
                      isvalid_setRonca(true);
                    }
                    if (TieneCirugias == null) {
                      isvalid_setTieneCirugias(true);
                    }
                    if (!EspecifiqueCirugias && TieneCirugias == 1) {
                      isvalid_setEspecifiqueCirugias(true);
                    }
                    if (ProblemaAlimentacion == null) {
                      isvalid_setProblemaAlimentacion(true);
                    }
                    if (!EspecifiqueProbAlimenta && ProblemaAlimentacion == 1) {
                      isvalid_setEspecifiqueProbAlimenta(true);
                    }
                    if (Hospitalizado == null) {
                      isvalid_setHospitalizado(true);
                    }
                    if (IdInfeccionCMV == null) {
                      isvalid_setIdInfeccionCMV(true);
                    }
                  }}
                  onBlur={() => {
                    if (
                      !EspecifiqueInfeccionCMV &&
                      IdInfeccionCMV != null &&
                      IdInfeccionCMV == "1"
                    ) {
                      isvalid_setEspecifiqueInfeccionCMV(true);
                    }
                  }}
                  size="small"
                  style={{ marginBottom: "1rem" }}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        {vista === "visualizar" ? null : (
          <MDBox textAlign="right">
            <Button
              variant="contained"
              onClick={() => ValidaForm()}
              sx={{ mt: 1, mr: 1 }}
              size="small"
              color="primary"
            >
              {"Continuar"}
            </Button>
            <Button
              variant="contained"
              disabled={false}
              onClick={() => handleBack()}
              sx={{ mt: 1, mr: 1 }}
              color="secondary"
              size="small"
            >
              Volver
            </Button>
          </MDBox>
        )}
      </>
    );
  }
);
export default AntecedentesPerinatales;
